import { jsx as I, jsxs as j, Fragment as Ro } from "react/jsx-runtime";
import * as w from "react";
import ie, { useEffect as L, useCallback as X, forwardRef as O, Children as Ze, isValidElement as Ct, createElement as E, cloneElement as Vt, Fragment as Bt, useId as GA, useRef as k, useImperativeHandle as FA, useMemo as N, useContext as wt, createContext as mt, useState as y, useLayoutEffect as Wo, useReducer as SA } from "react";
import * as xA from "react-dom";
import MA, { flushSync as Ho, createPortal as jo } from "react-dom";
import { I as Lo } from "../index-71V2NsQg.js";
const Ys = ({
  themeName: e,
  overrides: t
} = {}) => {
  L(() => {
    e && document.documentElement.setAttribute("data-theme", e), t && Object.entries(t).forEach(([o, n]) => {
      document.documentElement.style.setProperty(o, n);
    });
  }, [e, t]);
}, Ye = {
  "--ll-base-unit": "var(--ll-base-unit)",
  "--ll-color-primary": "var(--ll-color-primary)",
  "--ll-color-primary-variant1": "var(--ll-color-primary-variant1)",
  "--ll-color-background": "var(--ll-color-background)",
  "--ll-color-surface": "var(--ll-color-surface)",
  "--ll-color-surface-variant1": "var(--ll-color-surface-variant1)",
  "--ll-color-surface-variant2": "var(--ll-color-surface-variant2)",
  "--ll-color-on-primary": "var(--ll-color-on-primary)",
  "--ll-color-on-primary-variant1": "var(--ll-color-on-primary-variant1)",
  "--ll-color-on-background": "var(--ll-color-on-background)",
  "--ll-color-on-background-variant1": "var(--ll-color-on-background-variant1)",
  "--ll-color-on-surface": "var(--ll-color-on-surface)",
  "--ll-color-on-surface-variant1": "var(--ll-color-on-surface-variant1)",
  "--ll-color-placeholder": "var(--ll-color-placeholder)",
  "--ll-color-disabled": "var(--ll-color-disabled)",
  "--ll-color-border": "var(--ll-color-border)",
  "--ll-color-link": "var(--ll-color-link)",
  "--ll-sdk-title-color": "var(--ll-sdk-title-color)",
  "--ll-color-error": "var(--ll-color-error)",
  "--ll-border-radius-base-unit": "var(--ll-border-radius-base-unit)",
  "--ll-border-radius-small": "var(--ll-border-radius-small)",
  "--ll-border-radius-medium": "var(--ll-border-radius-medium)",
  "--ll-border-radius-large": "var(--ll-border-radius-large)",
  "--ll-shadow-small": "var(--ll-shadow-small)",
  "--ll-shadow-medium": "var(--ll-shadow-medium)",
  "--ll-spacing-base-unit": "var(--ll-spacing-base-unit)",
  "--ll-spacing-auto": "var(--ll-spacing-auto)",
  "--ll-spacing-xx-small": "var(--ll-spacing-xx-small)",
  "--ll-spacing-x-small": "var(--ll-spacing-x-small)",
  "--ll-spacing-small": "var(--ll-spacing-small)",
  "--ll-spacing-medium": "var(--ll-spacing-medium)",
  "--ll-spacing-large": "var(--ll-spacing-large)",
  "--ll-spacing-x-large": "var(--ll-spacing-x-large)",
  "--ll-spacing-xx-large": "var(--ll-spacing-xx-large)",
  "--ll-spacing-xxx-large": "var(--ll-spacing-xxx-large)",
  "--ll-font-family": "var(--ll-font-family)",
  "--ll-font-family-mono": "var(--ll-font-family-mono)",
  "--ll-font-size-base": "var(--ll-font-size-base)",
  "--ll-font-size-h1": "var(--ll-font-size-h1)",
  "--ll-font-size-h2": "var(--ll-font-size-h2)",
  "--ll-font-size-h3": "var(--ll-font-size-h3)",
  "--ll-font-size-h4": "var(--ll-font-size-h4)",
  "--ll-font-size-h5": "var(--ll-font-size-h5)",
  "--ll-font-size-h6": "var(--ll-font-size-h6)",
  "--ll-font-size-p": "var(--ll-font-size-p)",
  "--ll-font-size-caption-1": "var(--ll-font-size-caption-1)",
  "--ll-font-size-caption-2": "var(--ll-font-size-caption-2)",
  "--ll-font-weight-light": "var(--ll-font-weight-light)",
  "--ll-font-weight-normal": "var(--ll-font-weight-normal)",
  "--ll-font-weight-medium": "var(--ll-font-weight-medium)",
  "--ll-font-weight-semibold": "var(--ll-font-weight-semibold)",
  "--ll-font-weight-bold": "var(--ll-font-weight-bold)"
}, so = 4, KA = {
  colorPrimary100: "#FFFFFF",
  colorPrimary99: "#04162d",
  colorPrimary95: "#C8F9FF",
  colorPrimary90: "#87F2FF",
  colorPrimary80: "#4ED8E9",
  colorPrimary70: "#21BCCC",
  colorPrimary60: "#00A0AF",
  colorPrimary50: "#008491",
  colorPrimary40: "#006974",
  colorPrimary30: "#004F57",
  colorPrimary20: "#00363C",
  colorPrimary10: "#001F23",
  colorPrimary0: "#000000"
}, Rt = {
  colorNeutral100: "#FFFFFF",
  colorNeutral99: "#FBFDFD",
  colorNeutral95: "#EFF1F1",
  colorNeutral90: "#E0E3E3",
  colorNeutral80: "#C4C7C7",
  colorNeutral70: "#A9ACAC",
  colorNeutral60: "#8E9191",
  colorNeutral50: "#747878",
  colorNeutral40: "#5C5F5F",
  colorNeutral30: "#444747",
  colorNeutral20: "#2D3131",
  colorNeutral10: "#191C1D",
  colorNeutral0: "#000000"
}, yA = {
  colorBlue70: "#0056D3"
}, JA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  blueColors: yA,
  neutralColors: Rt,
  primaryColors: KA
}, Symbol.toStringTag, { value: "Module" })), ZA = (e) => e, kA = ZA({
  default: {
    ease: "easeInOut",
    duration: 0.15
  },
  defaultSlow: {
    ease: "easeInOut",
    duration: 0.4
  },
  spring: {
    type: "spring",
    duration: 0.4,
    bounce: 0.3
  }
}), UA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  transitions: kA
}, Symbol.toStringTag, { value: "Module" })), RA = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptopS: 1024,
  laptopL: 1440,
  desktop: 2560
}, WA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  screenSizes: RA
}, Symbol.toStringTag, { value: "Module" })), qs = {
  colors: JA,
  ...UA,
  ...WA
}, HA = `
  whitespace-nowrap inline-flex justify-center
  rounded-md leading-3 text-ll-font-size-caption-1

  data-[size=small]:py-0.5
  data-[size=small]:px-1
  data-[size=medium]:py-1
  data-[size=medium]:px-2
  data-[size=large]:py-1.5
  data-[size=large]:px-4
  `, bs = ({
  text: e,
  size: t = "small",
  className: o,
  textColor: n = Rt.colorNeutral10,
  backgroundColor: A = Rt.colorNeutral90,
  onClick: i
}) => /* @__PURE__ */ I(
  "div",
  {
    onClick: i,
    className: `${o} ${HA}`,
    style: {
      color: `${n}`,
      backgroundColor: `${A}`
    },
    "data-size": t,
    children: e
  }
), jA = "[&>svg]:fill-inherit", zt = ({
  SVGElement: e,
  fill: t = `${Ye["--ll-color-on-background"]}`,
  className: o,
  height: n = 24,
  width: A = 24
}) => /* @__PURE__ */ I("div", { className: `${o} ${jA}`, style: { height: `${n}px`, width: `${A}px`, fill: t }, children: /* @__PURE__ */ I(e, {}) }), LA = `
  m-0 mb-2
  data-[nomargin=true]:mb-0
  data-[align=left]:text-left
  data-[align=center]:text-center
  data-[align=right]:text-right
  data-[variant=h1]:text-ll-font-size-h1
  data-[variant=h2]:text-ll-font-size-h2
  data-[variant=h3]:text-ll-font-size-h3
  data-[variant=h4]:text-ll-font-size-h4
  data-[variant=h5]:text-ll-font-size-h5
  data-[variant=h6]:text-ll-font-size-h6
  data-[variant=p]:text-ll-font-size-p
  data-[variant=caption1]:text-ll-font-size-caption-1
  data-[variant=caption2]:text-ll-font-size-caption-2
  data-[texttransform=capitalize]:capitalize
  data-[texttransform=uppercase]:uppercase
  data-[texttransform=lowercase]:lowercase
  data-[texttransform=none]:normal-case
  data-[family=sans-serif]:font-sans
  data-[family=mono]:font-mono

  data-[lineclamp=none]:line-clamp-none
  data-[lineclamp=none]:whitespace-nowrap
  data-[lineclamp="1"]:line-clamp-1
  data-[lineclamp="2"]:line-clamp-2
  data-[lineclamp="3"]:line-clamp-3
  data-[lineclamp="4"]:line-clamp-4
  data-[lineclamp="5"]:line-clamp-5
  data-[lineclamp="6"]:line-clamp-g
`, pe = ({
  children: e,
  variant: t = "p",
  align: o,
  color: n = "--ll-color-on-background",
  lineClamp: A,
  noMargin: i,
  lineHeight: c,
  weight: r = "normal",
  family: a = "sans-serif",
  className: l,
  textTransform: d = "none",
  letterSpacing: s,
  fontVariant: m = "initial"
}) => {
  const C = `${["caption1", "caption2", "p"].includes(t) ? "p" : t}`, g = n in Ye ? Ye[n] : n;
  return /* @__PURE__ */ I(
    C,
    {
      style: {
        color: `${g}`,
        fontVariant: `${m}`,
        lineHeight: c || "1.45",
        letterSpacing: `${s}`,
        fontWeight: Ye[r]
      },
      className: `${l} ${LA}`,
      "data-align": o,
      "data-variant": t,
      "data-texttransform": d,
      "data-family": a,
      "data-nomargin": i,
      "data-lineclamp": A,
      children: e
    }
  );
}, PA = `
  font-sans
  text-ll-font-size-p
  text-ll-link
  cursor-pointer
`, NA = `
  overflow-hidden
  text-ellipsis
`, Ds = ({ children: e, href: t, className: o, lineClamp: n, download: A }) => /* @__PURE__ */ I(
  "a",
  {
    href: t,
    target: "_blank",
    rel: "noreferrer",
    className: `${o} ${PA} ${n ? `${NA} line-clamp-${n}` : ""}`,
    download: A,
    children: e
  }
);
function b() {
  return b = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var n in o)
        ({}).hasOwnProperty.call(o, n) && (e[n] = o[n]);
    }
    return e;
  }, b.apply(null, arguments);
}
function TA(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Po(...e) {
  return (t) => e.forEach(
    (o) => TA(o, t)
  );
}
function $(...e) {
  return X(Po(...e), e);
}
const Re = /* @__PURE__ */ O((e, t) => {
  const { children: o, ...n } = e, A = Ze.toArray(o), i = A.find(zA);
  if (i) {
    const c = i.props.children, r = A.map((a) => a === i ? Ze.count(c) > 1 ? Ze.only(null) : /* @__PURE__ */ Ct(c) ? c.props.children : null : a);
    return /* @__PURE__ */ E(Wt, b({}, n, {
      ref: t
    }), /* @__PURE__ */ Ct(c) ? /* @__PURE__ */ Vt(c, void 0, r) : null);
  }
  return /* @__PURE__ */ E(Wt, b({}, n, {
    ref: t
  }), o);
});
Re.displayName = "Slot";
const Wt = /* @__PURE__ */ O((e, t) => {
  const { children: o, ...n } = e;
  return /* @__PURE__ */ Ct(o) ? /* @__PURE__ */ Vt(o, {
    ...XA(n, o.props),
    ref: t ? Po(t, o.ref) : o.ref
  }) : Ze.count(o) > 1 ? Ze.only(null) : null;
});
Wt.displayName = "SlotClone";
const VA = ({ children: e }) => /* @__PURE__ */ E(Bt, null, e);
function zA(e) {
  return /* @__PURE__ */ Ct(e) && e.type === VA;
}
function XA(e, t) {
  const o = {
    ...t
  };
  for (const n in t) {
    const A = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? A && i ? o[n] = (...r) => {
      i(...r), A(...r);
    } : A && (o[n] = A) : n === "style" ? o[n] = {
      ...A,
      ...i
    } : n === "className" && (o[n] = [
      A,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...o
  };
}
const $A = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], V = $A.reduce((e, t) => {
  const o = /* @__PURE__ */ O((n, A) => {
    const { asChild: i, ...c } = n, r = i ? Re : t;
    return L(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ E(r, b({}, c, {
      ref: A
    }));
  });
  return o.displayName = `Primitive.${t}`, {
    ...e,
    [t]: o
  };
}, {});
function _A(e, t) {
  e && Ho(
    () => e.dispatchEvent(t)
  );
}
const ei = /* @__PURE__ */ O((e, t) => /* @__PURE__ */ E(V.label, b({}, e, {
  ref: t,
  onMouseDown: (o) => {
    var n;
    (n = e.onMouseDown) === null || n === void 0 || n.call(e, o), !o.defaultPrevented && o.detail > 1 && o.preventDefault();
  }
}))), ti = ei, oi = `
  text-ll-font-size-p text-ll-on-background font-sans
`, ni = (e) => /* @__PURE__ */ I(ti, { className: oi, ...e }), Ai = (e) => /* @__PURE__ */ w.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z" })), ii = "data:image/gif;base64,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", ri = `
  border-solid 
  border-ll-on-surface-variant1
  border-b-[transparent]
  rounded-[50%]
  inline-block
  border-box
  animate-spin

  data-[color=white]:border-white
  data-[color=white]:border-b-[transparent]

  data-[size=small]:h-4
  data-[size=small]:w-4
  data-[size=small]:border-2

  data-[size=medium]:h-6
  data-[size=medium]:w-6
  data-[size=medium]:border-4

  data-[size=large]:h-8
  data-[size=large]:w-8
  data-[size=large]:border-[6px]
`, ci = "h-[90px] w-[90px] max-h-auto", No = ({
  size: e = "medium",
  image: t,
  color: o = "default"
}) => t ? /* @__PURE__ */ I(
  "img",
  {
    src: ii,
    alt: "Loading animation",
    width: 90,
    height: 90,
    className: ci
  }
) : /* @__PURE__ */ I("div", { className: ri, "data-size": e, "data-color": o }), ai = `
  group
  font-normal rounded inline-flex items-center justify-center cursor-pointer
  bg-transparent border-0 box-border h-10 py-0 px-3
  text-ll-font-size-p

  disabled:cursor-default

  data-[size=small]:h-8
  data-[size=small]:px-2
  data-[size=small]:text-ll-font-size-caption-1

  data-[size=large]:h-12
  data-[size=large]:px-4

  data-[variant=contained]:bg-ll-primary
  data-[variant=contained]:text-ll-on-primary
  data-[variant=contained]:border
  data-[variant=contained]:border-solid
  data-[variant=contained]:border-transparent
  data-[variant=contained]:hover:bg-ll-primary-variant1
  data-[variant=contained]:disabled:bg-ll-disabled
  

  data-[variant=outlined]:bg-ll-background
  data-[variant=outlined]:text-ll-primary
  data-[variant=outlined]:border
  data-[variant=outlined]:border-solid
  data-[variant=outlined]:border-ll-primary
  data-[variant=outlined]:hover:bg-ll-surface-variant1
  data-[variant=outlined]:disabled:bg-ll-disabled
  data-[variant=outlined]:disabled:text-ll-on-primary
  data-[variant=outlined]:disabled:border-ll-on-background

  data-[variant=text]:text-ll-on-background
`, li = `
  flex items-center mr-2 ml-1
  [&>svg]:fill-current [&>svg]:h-5 [&>svg]:w-5

  group-data-[size=small]:[&>svg]:h-3
  group-data-[size=small]:[&>svg]:w-3

  group-data-[size=large]:[&>svg]:h-6
  group-data-[size=large]:[&>svg]:w-6
`, To = ie.forwardRef(
  ({
    children: e,
    disabled: t = !1,
    onClick: o,
    variant: n = "contained",
    startAdornment: A,
    size: i = "medium",
    type: c = "button",
    isLoading: r,
    className: a,
    props: l
  }, d) => /* @__PURE__ */ I(
    "button",
    {
      "data-variant": n,
      "data-size": i,
      onClick: (m) => {
        t || o && (r || o(m));
      },
      disabled: t || r,
      className: ai,
      type: c,
      ref: d,
      ...l,
      children: r ? /* @__PURE__ */ I(No, {}) : /* @__PURE__ */ j(Ro, { children: [
        A && /* @__PURE__ */ I("div", { className: li, children: A }),
        e
      ] })
    }
  )
);
To.displayName = "Button";
const si = `
  flex flex-col flex-1
`, gi = `
  border flex items-center bg-ll-background
  rounded-sm focus-within:shadow-lg
  data-[has-error=true]:border-ll-error
  data-[has-error=false]:border-ll-border
`, di = `
  border flex-1 text-ll-on-background h-[30px]
  inline-flex justify-center items-center py-0 px-2
  leading-none font-sans text-ll-font-size-h6 md:text-ll-font-size-p 
  `, ui = `
  h-full w-[20px] flex justify-center items-center mx-2
`, Ci = O(
  ({
    name: e,
    value: t,
    label: o,
    placeholder: n,
    className: A,
    autofocus: i = !1,
    hasError: c = !1,
    adornment: r,
    onBlur: a,
    onFocus: l,
    onClear: d,
    onChange: s
  }, m) => {
    const u = GA(), C = k(null), g = k(null);
    FA(m, () => ({
      focus: () => {
        var h;
        (h = C == null ? void 0 : C.current) == null || h.focus();
      },
      get input() {
        return C.current;
      },
      get container() {
        return g.current;
      }
    }));
    const f = N(() => o ? /* @__PURE__ */ I(ni, { htmlFor: u, style: { lineHeight: "26px" }, children: o }) : null, [o]);
    return /* @__PURE__ */ j("div", { className: si, ref: g, children: [
      f,
      /* @__PURE__ */ j("div", { className: gi, "data-has-error": c, children: [
        r && /* @__PURE__ */ I("span", { className: ui, children: r }),
        /* @__PURE__ */ I(
          "input",
          {
            type: "text",
            className: `${A} ${di}`,
            ref: C,
            name: e,
            autoFocus: i,
            id: u,
            value: t,
            onBlur: a,
            onFocus: l,
            onChange: s,
            placeholder: n,
            style: r && { width: "-webkit-fill-available" }
          }
        ),
        d && /* @__PURE__ */ I(To, { size: "small", variant: "text", onClick: d, children: /* @__PURE__ */ I(Ai, {}) })
      ] })
    ] });
  }
);
Ci.displayName = "Input";
function mi({
  title: e,
  titleId: t,
  ...o
}, n) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, o), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
    clipRule: "evenodd"
  }));
}
const hi = w.forwardRef(mi);
function fi({
  title: e,
  titleId: t,
  ...o
}, n) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, o), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }));
}
const pi = w.forwardRef(fi);
function Ii({
  title: e,
  titleId: t,
  ...o
}, n) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, o), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    clipRule: "evenodd"
  }));
}
const Bi = w.forwardRef(Ii);
function wi({
  title: e,
  titleId: t,
  ...o
}, n) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: n,
    "aria-labelledby": t
  }, o), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
    clipRule: "evenodd"
  }));
}
const Ei = w.forwardRef(wi), Qi = `
    h-5 w-5 
    group-data-[type=error]:text-red-400
    group-data-[type=warning]:text-yellow-400
    group-data-[type=success]:text-green-400
    group-data-[type=info]:text-blue-400
`, vi = `
    rounded-md p-4 group
    data-[type=error]:bg-red-50
    data-[type=warning]:bg-yellow-50
    data-[type=success]:bg-green-50
    data-[type=info]:bg-blue-50 
`, Yi = `
    text-sm font-medium [overflow-wrap:anywhere] 
    group-data-[type=error]:text-red-800
    group-data-[type=warning]:text-yellow-800
    group-data-[type=success]:text-green-800
    group-data-[type=info]:text-blue-800
`, qi = `
    mt-2 text-sm [overflow-wrap:anywhere] 
    group-data-[type=error]:text-red-700
    group-data-[type=warning]:text-yellow-700
    group-data-[type=success]:text-green-700
    group-data-[type=info]:text-blue-700
`, bi = "flex", Di = "flex-shrink-0", Oi = "ml-3", Gi = {
  error: Ei,
  warning: pi,
  success: hi,
  info: Bi
}, Os = ({ title: e, message: t, type: o = "warning" }) => {
  const n = Gi[o];
  return /* @__PURE__ */ I("div", { className: vi, "data-type": o, children: /* @__PURE__ */ j("div", { className: bi, children: [
    /* @__PURE__ */ I("div", { className: Di, children: /* @__PURE__ */ I(n, { className: Qi, "aria-hidden": !0 }) }),
    /* @__PURE__ */ j("div", { className: Oi, children: [
      /* @__PURE__ */ I("h3", { className: Yi, children: e }),
      t && /* @__PURE__ */ I("p", { className: qi, children: t })
    ] })
  ] }) });
}, go = {
  small: 20,
  medium: 32,
  large: 40
}, Fi = {
  small: "h-5 w-5",
  medium: "h-8 w-8",
  large: "h-10 w-10"
}, Si = (e, t, o) => {
  const n = Fi[e];
  return `
    ${o ? "scale-125" : "hover:scale-125 ease-in-out duration-150"}
    flex justify-center items-center
    border-2 border-white
    rounded-full ${n} ${t ? "shadow-sm" : "shadow-none"}
`;
}, xi = ({
  fill: e = "#fff",
  backgroundColor: t = Ye["--ll-color-primary"],
  backgroundColorHighlight: o = t,
  SVGElement: n,
  size: A = "medium",
  expandMarker: i,
  renderForPrint: c = !1
}) => /* @__PURE__ */ I(
  "div",
  {
    "data-testid": "svgInfo",
    className: Si(
      A,
      c,
      i
    ),
    style: { background: `linear-gradient(to top, ${o}, ${t})` },
    children: /* @__PURE__ */ I(
      zt,
      {
        SVGElement: n,
        fill: e,
        height: go[A] / 1.5,
        width: go[A] / 1.5
      }
    )
  }
), Mi = "shrink-0", Gs = ({
  vertical: e = !1,
  spacing: t = "--ll-spacing-auto"
}) => (
  // Horizontal spacer (vertical false) needs parent to be display: flex 
  /* @__PURE__ */ I(
    "div",
    {
      className: Mi,
      style: e ? { margin: `var(${t}) 0 0 0` } : { margin: `0 var(${t}) 0 0` }
    }
  )
), Ki = `
  group border-none rounded-full flex justify-center items-center p-2

  disabled:cursor-default
  disabled:bg-[rgba(0, 0, 0, 0.1)]
  disabled:text-ll-on-background-variant1

  data-[size=small]:w-6
  data-[size=small]:h-6
  data-[size=medium]:w-8
  data-[size=medium]:h-8
  data-[size=large]:w-12
  data-[size=large]:h-12

  data-[type=primary]:text-ll-on-primary
  data-[type=primary]:bg-ll-primary
  data-[type=primary]:hover:bg-ll-primary-variant1

  data-[type=inverse]:text-ll-primary
  data-[type=inverse]:transparent
  data-[type=inverse]:hover:bg-[rgba(0,0,0,0.05)]

  data-[type=neutral]:text-ll-on-background-variant1
  data-[type=neutral]:bg-transparent
  data-[type=neutral]:hover:bg-[rgba(0,0,0,0.05)]
`, yi = `
  group-data-[type=primary]:fill-ll-on-primary
  group-data-[type=inverse]:fill-ll-primary
  group-data-[type=neutral]:fill-ll-on-background-variant1
`, Fs = ({
  className: e,
  color: t = "primary",
  disabled: o = !1,
  isLoading: n,
  onClick: A,
  size: i = "medium",
  icon: c,
  title: r,
  type: a = "button"
}) => /* @__PURE__ */ I(
  "button",
  {
    onClick: (d) => {
      o || A && (n || A(d));
    },
    disabled: o || n,
    className: `${Ki} ${e}`,
    "data-type": t,
    "data-size": i,
    title: r,
    type: a,
    children: n ? /* @__PURE__ */ I(No, {}) : /* @__PURE__ */ I(Lo, { icon: c, className: yi })
  }
), Ji = (e, t) => {
  const o = e ? `h-[${e}]` : "h-[50px]", n = t ? `w-[${t}]` : "w-full";
  return `
    ${o}
    ${n}
    flex
    rounded-lg
    animate-shimmer
    bg-gradient-to-r from-ll-surface-variant1 via-ll-surface-variant2 to-ll-surface-variant1 bg-shimmer
  `;
}, Ss = ({ height: e, width: t, className: o }) => /* @__PURE__ */ I("div", { className: `${Ji(e, t)} ${o}` }), Zi = ie.createContext(
  {}
), ki = `
  bg-ll-surface p-3
  rounded-md h-full box-border
  text-ll-on-background
`, Ui = `
  w-full h-[calc(100%-32px)]
  flex flex-col align-middle justify-center
  box-border
`, Ri = `
  w-full
  flex items-center
  mb-1 last:mb-0 lg:mb-2
  data-[single="false"]:flex-row
  data-[single="false"]:justify-between
  data-[single="true"]:flex-col
  data-[single="true"]:justify-center
  `, Wi = `
  flex items-center justify-center
`, Hi = `
  [&>svg]:fill-black
  data-[single="false"]:[&>svg]:h-[32px]
  data-[single="false"]:[&>svg]:w-[32px]
  data-[single="true"]:[&>svg]:h-[64px]
  data-[single="true"]:[&>svg]:w-[64px]
`, ji = `
  text-sm
`, Li = `
  font-normal  text-ll-font-size-h2
`, Pi = `
  font-normal
`, Ni = `
  font-normal
  text-ll-font-size-p
`, Et = ({
  options: { title: e, values: t }
}) => {
  const o = N(() => ({
    isSingleItem: (t == null ? void 0 : t.length) === 1
  }), [t]);
  return /* @__PURE__ */ j("div", { className: ki, children: [
    /* @__PURE__ */ I("p", { className: Ni, children: e }),
    /* @__PURE__ */ I("div", { className: Ui, children: t == null ? void 0 : t.map((n) => /* @__PURE__ */ j("div", { className: Ri, "data-single": o.isSingleItem, children: [
      /* @__PURE__ */ j("div", { className: Wi, children: [
        o.isSingleItem && (n.SVGElement || n.icon) && /* @__PURE__ */ j("div", { className: Hi, "data-single": o.isSingleItem, children: [
          n.SVGElement && /* @__PURE__ */ I(n.SVGElement, {}),
          n.icon && /* @__PURE__ */ I(Lo, { icon: n.icon })
        ] }),
        !o.isSingleItem && /* @__PURE__ */ I("p", { className: ji, children: n.label })
      ] }),
      o.isSingleItem ? /* @__PURE__ */ I("h2", { className: Li, children: n.value }) : /* @__PURE__ */ I("p", { className: Pi, children: n.value })
    ] }, n.variable)) })
  ] });
}, Ti = "Population By Age Group", uo = "Total Population", Vi = "Type of Housing", zi = "Owners vs Renters", Vo = "Household Composition", Xi = "Average Income", $i = "Commute Mode", _i = "Highest Level Of Education Achieved", er = "Mother Tongue", tr = "Income Brackets", or = "Spoken Official Languages", nr = {
  avg_household_income: "Family",
  avg_individual_income: "Individual"
}, Ar = "Employment", ir = ({
  options: { incomeTypes: e }
}) => {
  const t = N(
    () => ({
      options: {
        title: Xi,
        values: e.map((o) => ({
          variable: o.variable,
          value: `${new Intl.NumberFormat("en-EN", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 1
          }).format(o.value / 1e3)}${o.value >= 1e3 ? "k" : ""}`,
          label: nr[o.variable]
        }))
      }
    }),
    [e]
  );
  return /* @__PURE__ */ I(Et, { ...t });
}, zo = ie.createContext({}), Xt = () => wt(zo), rr = `
  relative aspect-square rounded-full flex items-center justify-center overflow-hidden
`, cr = `
  bg-ll-surface rounded-full w-[70%] h-[70%]
  z-10 flex items-center justify-center
`, ar = `
  flex items-center justify-center
  w-full h-full

  [&>svg]:w-1/2
  [&>svg]:w-1/2
  [&>svg>path]:fill-ll-primary
`, Xo = ({ className: e }) => {
  const { data: t, colors: o, icon: n } = Xt(), A = t.reduce((c, r) => c + r, 0), i = N(
    () => t.map((c, r) => {
      const l = c / A * 100 > 50, s = t.slice(0, r).reduce((f, h) => f + h, 0) / A * 360, m = c / A * 360, u = l ? "-100%" : "0%", C = l ? "200%" : "100%", g = `polygon(${u} ${u}, ${C} ${u}, ${C} ${C}, ${u} ${C})`;
      return /* @__PURE__ */ I(
        "div",
        {
          className: "ll-donut-segment",
          style: {
            zIndex: `calc(1 + ${l ? 2 : 1})`,
            "--ll-chart-donut-segment-clip-path": g,
            "--ll-chart-donut-segment-bg": (o == null ? void 0 : o[r]) ?? "#000",
            "--ll-chart-donut-segment-degrees": s,
            "--ll-chart-donut-segment-before-degrees": m,
            "--ll-chart-donut-segment-opacity": l ? 1 : 0
          }
        },
        `segment-${r}`
      );
    }),
    [t, o]
  );
  return /* @__PURE__ */ j("div", { className: rr, children: [
    i,
    /* @__PURE__ */ I("div", { className: cr, children: /* @__PURE__ */ I("div", { className: ar, children: n }) })
  ] });
}, lr = "list-none p-0", sr = "flex items-center", gr = "w-3 h-3 rounded mr-2.5", $o = () => {
  const { labels: e, colors: t } = Xt();
  return /* @__PURE__ */ I("ul", { className: lr, children: e.map((o, n) => /* @__PURE__ */ j("li", { className: sr, children: [
    /* @__PURE__ */ I(
      "div",
      {
        className: gr,
        style: {
          backgroundColor: (t == null ? void 0 : t[n]) || "#000"
        }
      }
    ),
    /* @__PURE__ */ I(pe, { noMargin: !0, lineClamp: 1, variant: "caption1", children: o })
  ] }, o)) });
}, dr = `
  h-full w-full overflow-hidden bg-ll-surface
  rounded-md p-3 flex flex-col
`, ur = "h-[6%] min-h-5", Cr = "grow mx-0 my-2 grid gap-y-1", mr = `
  border-t border-ll-placeholder border-solid
  h-[6%] min-h-3 w-[calc(100%-165px)]
  ml-[140px] grid grid-cols-3
`, hr = `
  grid grid-rows-1 grid-cols-[140px_calc(100%-165px)]
  gap-y-1 items-center
`, fr = `
  relative py-0.5 px-2.5 h-full
  flex justify-start items-center
`, pr = `
  z-10 flex items-center justify-center
  h-full w-10 absolute top-0
`, Ir = `
  bg-ll-primary rounded-r-md inline-block h-full absolute top-0 bottom-0 left-0
`, je = ({ className: e }) => {
  const { title: t, labels: o, data: n, unit: A } = Xt(), i = [...n].sort((a, l) => a - l).reverse()[0], c = N(() => A ? Math.ceil(i / 10) * 10 : 100, [A]), r = N(
    () => n.map((a, l) => ({
      label: o[l],
      value: a,
      width: Math.round(a * 100 / c)
    })),
    [n, o]
  );
  return /* @__PURE__ */ j("div", { className: dr, children: [
    /* @__PURE__ */ I("div", { className: ur, children: /* @__PURE__ */ I(pe, { variant: "p", noMargin: !0, weight: "--ll-font-weight-bold", children: `${t} (${A})` }) }),
    /* @__PURE__ */ I("div", { className: Cr, children: r.map((a) => /* @__PURE__ */ j("div", { className: hr, children: [
      a.label !== "0" && /* @__PURE__ */ I(pe, { noMargin: !0, variant: "caption2", children: a.label }),
      /* @__PURE__ */ j("div", { className: fr, children: [
        /* @__PURE__ */ I("div", { className: pr, style: {
          left: `${a.width}%`
        }, children: /* @__PURE__ */ j(
          pe,
          {
            noMargin: !0,
            align: "center",
            color: "--ll-color-on-background",
            variant: "caption2",
            children: [
              a.value,
              A
            ]
          }
        ) }),
        /* @__PURE__ */ I(
          "span",
          {
            className: Ir,
            style: {
              width: `${a.width}%`
            }
          }
        )
      ] })
    ] }, a.label)) }),
    /* @__PURE__ */ j("div", { className: mr, children: [
      /* @__PURE__ */ I(pe, { noMargin: !0, variant: "caption2", color: "--ll-color-on-background", children: "0" }),
      /* @__PURE__ */ I(pe, { noMargin: !0, variant: "caption2", align: "center", color: "--ll-color-on-background", children: `${c / 2}${A}` }),
      /* @__PURE__ */ I(pe, { noMargin: !0, variant: "caption2", align: "right", color: "--ll-color-on-background", children: `${c}${A}` })
    ] })
  ] });
}, Br = [
  "rgb(0, 188,202)",
  "rgb(208,232,233)",
  "rgb(243,209,130)",
  "rgb(255,116,16)",
  "rgb(52,65,181)",
  "rgb(151,184,126)",
  "rgb(0,132,145)",
  "rgb(62,49,91)"
], Se = (e) => /* @__PURE__ */ I(zo.Provider, { value: { ...e, colors: e.colors ?? Br }, children: e.children }), xs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BarChart: je,
  Donut: Xo,
  Legend: $o,
  Root: Se
}, Symbol.toStringTag, { value: "Module" })), wr = ({
  options: { labels: e, data: t }
}) => {
  const o = N(
    () => ({
      title: `${Ti}`,
      labels: e,
      data: t,
      unit: "%"
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Se, { ...o, children: /* @__PURE__ */ I(je, {}) });
}, Er = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M15.9993 21.4817C17.8437 21.4817 19.3388 19.7413 19.3388 17.5944C19.3388 15.4475 17.8437 13.707 15.9993 13.707C14.1549 13.707 12.6598 15.4475 12.6598 17.5944C12.6598 19.7413 14.1549 21.4817 15.9993 21.4817Z" }), /* @__PURE__ */ w.createElement("path", { d: "M17.416 21.7468H14.5824C12.2249 21.7468 10.3069 23.9803 10.3069 26.7241V30.7591L10.3156 30.8217L10.554 30.9082C12.8038 31.7267 14.7588 32 16.3681 32C19.5101 32 21.3312 30.9565 21.4437 30.8908L21.6668 30.7583L21.6899 30.7591V26.7237C21.6915 23.9803 19.7741 21.7468 17.416 21.7468Z" }), /* @__PURE__ */ w.createElement("path", { d: "M9.1822 12.5421C12.1575 12.5421 14.5695 9.73444 14.5695 6.27104C14.5695 2.80764 12.1575 0 9.1822 0C6.20689 0 3.79492 2.80764 3.79492 6.27104C3.79492 9.73444 6.20689 12.5421 9.1822 12.5421Z" }), /* @__PURE__ */ w.createElement("path", { d: "M22.8159 12.5421C25.7912 12.5421 28.2025 9.7333 28.2025 6.27028C28.2025 2.8084 25.7902 0 22.8159 0C19.8399 0 17.429 2.80764 17.429 6.27028C17.429 9.73293 19.8399 12.5421 22.8159 12.5421Z" }), /* @__PURE__ */ w.createElement("path", { d: "M13.3808 21.1353C12.5256 20.2768 11.9817 19.0091 11.9817 17.5949C11.9817 15.8606 12.7986 14.3467 14.0064 13.5392C13.2199 13.1749 12.365 12.9688 11.4683 12.9688H6.89699C3.09401 12.9684 0 16.5715 0 20.9975V27.5064L0.0139458 27.608L0.398914 27.7473C3.9606 29.0429 7.06109 29.4888 9.62841 29.505V26.7238C9.62841 24.0268 11.2289 21.7632 13.3808 21.1353Z" }), /* @__PURE__ */ w.createElement("path", { d: "M25.1018 12.9683H20.5311C19.6344 12.9683 18.7805 13.1744 17.9937 13.5387C19.2024 14.3462 20.0194 15.8593 20.0194 17.5944C20.0194 19.0079 19.4751 20.2756 18.6206 21.1341C19.482 21.3836 20.2749 21.8967 20.9193 22.6472C21.856 23.7382 22.372 25.1864 22.3716 26.7245V29.5049C24.939 29.4887 28.0398 29.0424 31.6008 27.7472L31.9858 27.6079L32.0001 27.5063V20.9974C31.9988 16.5713 28.9047 12.9683 25.1018 12.9683Z" })), Qr = ({
  options: { variable: e, value: t }
}) => {
  const o = N(
    () => ({
      options: {
        title: uo,
        values: [
          {
            variable: e,
            value: `${new Intl.NumberFormat("en-EN").format(t)}`,
            label: uo,
            SVGElement: Er
          }
        ]
      }
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Et, { ...o });
}, vr = ({
  options: { datasets: e }
}) => {
  const t = N(
    () => ({
      options: {
        title: zi,
        values: e.map((o) => ({
          variable: o.label.replace(" ", "_"),
          label: o.label,
          value: `${o.data}%`
        }))
      }
    }),
    [e]
  );
  return /* @__PURE__ */ I(Et, { ...t });
}, Yr = `
  w-full h-full
  overflow-hidden
  bg-ll-surface
  font-sans
  rounded-md
  p-3
`, qr = `
  mb-2
`, br = `
  items-center
  h-[80%]
  overflow-hidden
  my-0 mx-auto
  w-[90%] max-w-[380px] 
  flex flex-row
  justify-between
`, Dr = `
  w-[35%] md:w-[45%]
`, Qt = ({ title: e, labels: t, data: o, icon: n }) => /* @__PURE__ */ j("div", { className: Yr, children: [
  /* @__PURE__ */ I("div", { className: qr, children: /* @__PURE__ */ I(pe, { variant: "p", noMargin: !0, weight: "--ll-font-weight-bold", children: e }) }),
  /* @__PURE__ */ I(Se, { data: o, labels: t, icon: n, children: /* @__PURE__ */ j("div", { className: br, children: [
    /* @__PURE__ */ I("div", { className: Dr, children: /* @__PURE__ */ I(Xo, {}) }),
    /* @__PURE__ */ I(Ro, { children: /* @__PURE__ */ I($o, {}) })
  ] }) })
] }), _o = (e) => /* @__PURE__ */ w.createElement("svg", { width: 22, height: 20, viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M14.75 2C14.75 0.89 15.64 0 16.75 0C17.86 0 18.75 0.89 18.75 2C18.75 3.11 17.86 4 16.75 4C15.64 4 14.75 3.11 14.75 2ZM18.75 20V14H21.25L18.71 6.37C18.43 5.55 17.67 5 16.81 5H16.69C15.83 5 15.06 5.55 14.79 6.37L13.93 8.95C15.01 9.55 15.75 10.68 15.75 12V20H18.75ZM11.25 9.5C12.08 9.5 12.75 8.83 12.75 8C12.75 7.17 12.08 6.5 11.25 6.5C10.42 6.5 9.75 7.17 9.75 8C9.75 8.83 10.42 9.5 11.25 9.5ZM4.25 4C5.36 4 6.25 3.11 6.25 2C6.25 0.89 5.36 0 4.25 0C3.14 0 2.25 0.89 2.25 2C2.25 3.11 3.14 4 4.25 4ZM6.25 20V13H7.75V7C7.75 5.9 6.85 5 5.75 5H2.75C1.65 5 0.75 5.9 0.75 7V13H2.25V20H6.25ZM12.75 20V16H13.75V12C13.75 11.18 13.07 10.5 12.25 10.5H10.25C9.43 10.5 8.75 11.18 8.75 12V16H9.75V20H12.75Z" })), Or = ({ options: { labels: e, data: t } }) => {
  const o = N(
    () => ({
      title: `${Vo}`,
      labels: e,
      data: t,
      icon: /* @__PURE__ */ I(_o, {})
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Qt, { ...o });
}, Gr = ({ options: { labels: e, data: t } }) => {
  const o = N(
    () => ({
      title: `${Vo}`,
      labels: e,
      data: t,
      icon: /* @__PURE__ */ I(_o, {})
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Qt, { ...o });
}, Fr = ({
  options: { labels: e, data: t }
}) => {
  const o = N(
    () => ({
      title: `${Vi}`,
      labels: e,
      data: t,
      unit: "%"
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Se, { ...o, children: /* @__PURE__ */ I(je, {}) });
}, Sr = (e) => /* @__PURE__ */ w.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M12 4H5C3.34 4 2 5.34 2 7V15C2 16.66 3.34 18 5 18L4 19V20H5L7 18H9V13H4V6H13V8H15V7C15 5.34 13.66 4 12 4ZM5 14C5.55 14 6 14.45 6 15C6 15.55 5.55 16 5 16C4.45 16 4 15.55 4 15C4 14.45 4.45 14 5 14ZM20.57 9.66C20.43 9.26 20.05 9 19.6 9H12.41C11.95 9 11.58 9.26 11.43 9.66L10.01 13.77V19.28C10.01 19.66 10.32 20 10.7 20H11.32C11.7 20 12 19.62 12 19.24V18H20V19.24C20 19.62 20.31 20 20.69 20H21.3C21.68 20 21.99 19.66 21.99 19.28L22 17.91V13.77L20.57 9.66ZM12.41 10H19.6L20.63 13H11.38L12.41 10ZM12 16C11.45 16 11 15.55 11 15C11 14.45 11.45 14 12 14C12.55 14 13 14.45 13 15C13 15.55 12.55 16 12 16ZM20 16C19.45 16 19 15.55 19 15C19 14.45 19.45 14 20 14C20.55 14 21 14.45 21 15C21 15.55 20.55 16 20 16Z" })), xr = ({
  options: { labels: e, data: t }
}) => {
  const o = N(
    () => ({
      title: `${$i}`,
      labels: e,
      data: t,
      icon: /* @__PURE__ */ I(Sr, {})
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Qt, { ...o });
}, Mr = ({
  options: { labels: e, data: t }
}) => {
  const o = N(
    () => ({
      title: `${_i}`,
      labels: e,
      data: t,
      unit: "%"
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Se, { ...o, children: /* @__PURE__ */ I(je, {}) });
}, Kr = ({
  options: { datasets: e }
}) => {
  const t = N(
    () => ({
      options: {
        title: Ar,
        values: e.map((o) => ({
          variable: o.label.replace(" ", "_"),
          label: o.label,
          value: `${o.data}%`
        }))
      }
    }),
    [e]
  );
  return /* @__PURE__ */ I(Et, { ...t });
}, yr = ({
  options: { labels: e, data: t }
}) => {
  const o = N(
    () => ({
      title: `${tr}`,
      labels: e,
      data: t,
      unit: "%"
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Se, { ...o, children: /* @__PURE__ */ I(je, {}) });
}, Jr = ({
  options: { labels: e, data: t }
}) => {
  const o = N(
    () => ({
      title: `${er}`,
      labels: e,
      data: t,
      unit: "%"
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Se, { ...o, children: /* @__PURE__ */ I(je, {}) });
}, Zr = (e) => /* @__PURE__ */ w.createElement("svg", { width: 22, height: 20, viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M11.87 13.07L9.33 10.56L9.36 10.53C11.1 8.59 12.34 6.36 13.07 4H16V2H9V0H7V2H0V3.99H11.17C10.5 5.92 9.44 7.75 8 9.35C7.07 8.32 6.3 7.19 5.69 6H3.69C4.42 7.63 5.42 9.17 6.67 10.56L1.58 15.58L3 17L8 12L11.11 15.11L11.87 13.07ZM17.5 8H15.5L11 20H13L14.12 17H18.87L20 20H22L17.5 8ZM14.88 15L16.5 10.67L18.12 15H14.88Z" })), kr = ({
  options: { labels: e, data: t }
}) => {
  const o = N(
    () => ({
      title: `${or}`,
      labels: e,
      data: t,
      icon: /* @__PURE__ */ I(Zr, {})
    }),
    [e, t]
  );
  return /* @__PURE__ */ I(Qt, { ...o });
}, Ur = (e) => /* @__PURE__ */ I(Zi.Provider, { value: { ...e }, children: e.children }), Ms = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AvgIncomeCard: ir,
  CommuteModeCard: xr,
  EducationLevelChart: Mr,
  EmploymentStatusCard: Kr,
  FamiliesWithChildrenCard: Gr,
  HouseholdCompositionCard: Or,
  IncomeBracketsChart: yr,
  MotherTongueChart: Jr,
  OwnersRentersCard: vr,
  PopulationByAgeChart: wr,
  Root: Ur,
  SpokenLanguageCard: kr,
  TotalPopulationCard: Qr,
  TypeOfHousingChart: Fr
}, Symbol.toStringTag, { value: "Module" }));
function Co(e, [t, o]) {
  return Math.min(o, Math.max(t, e));
}
function T(e, t, { checkForDefaultPrevented: o = !0 } = {}) {
  return function(A) {
    if (e == null || e(A), o === !1 || !A.defaultPrevented)
      return t == null ? void 0 : t(A);
  };
}
function vt(e, t = []) {
  let o = [];
  function n(i, c) {
    const r = /* @__PURE__ */ mt(c), a = o.length;
    o = [
      ...o,
      c
    ];
    function l(s) {
      const { scope: m, children: u, ...C } = s, g = (m == null ? void 0 : m[e][a]) || r, f = N(
        () => C,
        Object.values(C)
      );
      return /* @__PURE__ */ E(g.Provider, {
        value: f
      }, u);
    }
    function d(s, m) {
      const u = (m == null ? void 0 : m[e][a]) || r, C = wt(u);
      if (C)
        return C;
      if (c !== void 0)
        return c;
      throw new Error(`\`${s}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [
      l,
      d
    ];
  }
  const A = () => {
    const i = o.map((c) => /* @__PURE__ */ mt(c));
    return function(r) {
      const a = (r == null ? void 0 : r[e]) || i;
      return N(
        () => ({
          [`__scope${e}`]: {
            ...r,
            [e]: a
          }
        }),
        [
          r,
          a
        ]
      );
    };
  };
  return A.scopeName = e, [
    n,
    Rr(A, ...t)
  ];
}
function Rr(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const o = () => {
    const n = e.map(
      (A) => ({
        useScope: A(),
        scopeName: A.scopeName
      })
    );
    return function(i) {
      const c = n.reduce((r, { useScope: a, scopeName: l }) => {
        const s = a(i)[`__scope${l}`];
        return {
          ...r,
          ...s
        };
      }, {});
      return N(
        () => ({
          [`__scope${t.scopeName}`]: c
        }),
        [
          c
        ]
      );
    };
  };
  return o.scopeName = t.scopeName, o;
}
function Wr(e) {
  const t = e + "CollectionProvider", [o, n] = vt(t), [A, i] = o(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), c = (u) => {
    const { scope: C, children: g } = u, f = ie.useRef(null), h = ie.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ ie.createElement(A, {
      scope: C,
      itemMap: h,
      collectionRef: f
    }, g);
  }, r = e + "CollectionSlot", a = /* @__PURE__ */ ie.forwardRef((u, C) => {
    const { scope: g, children: f } = u, h = i(r, g), p = $(C, h.collectionRef);
    return /* @__PURE__ */ ie.createElement(Re, {
      ref: p
    }, f);
  }), l = e + "CollectionItemSlot", d = "data-radix-collection-item", s = /* @__PURE__ */ ie.forwardRef((u, C) => {
    const { scope: g, children: f, ...h } = u, p = ie.useRef(null), B = $(C, p), Q = i(l, g);
    return ie.useEffect(() => (Q.itemMap.set(p, {
      ref: p,
      ...h
    }), () => void Q.itemMap.delete(p))), /* @__PURE__ */ ie.createElement(Re, {
      [d]: "",
      ref: B
    }, f);
  });
  function m(u) {
    const C = i(e + "CollectionConsumer", u);
    return ie.useCallback(() => {
      const f = C.collectionRef.current;
      if (!f)
        return [];
      const h = Array.from(f.querySelectorAll(`[${d}]`));
      return Array.from(C.itemMap.values()).sort(
        (Q, v) => h.indexOf(Q.ref.current) - h.indexOf(v.ref.current)
      );
    }, [
      C.collectionRef,
      C.itemMap
    ]);
  }
  return [
    {
      Provider: c,
      Slot: a,
      ItemSlot: s
    },
    m,
    n
  ];
}
const Hr = /* @__PURE__ */ mt(void 0);
function jr(e) {
  const t = wt(Hr);
  return e || t || "ltr";
}
function Ie(e) {
  const t = k(e);
  return L(() => {
    t.current = e;
  }), N(
    () => (...o) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...o);
    },
    []
  );
}
function Lr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const o = Ie(e);
  L(() => {
    const n = (A) => {
      A.key === "Escape" && o(A);
    };
    return t.addEventListener("keydown", n), () => t.removeEventListener("keydown", n);
  }, [
    o,
    t
  ]);
}
const Ht = "dismissableLayer.update", Pr = "dismissableLayer.pointerDownOutside", Nr = "dismissableLayer.focusOutside";
let mo;
const Tr = /* @__PURE__ */ mt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), en = /* @__PURE__ */ O((e, t) => {
  var o;
  const { disableOutsidePointerEvents: n = !1, onEscapeKeyDown: A, onPointerDownOutside: i, onFocusOutside: c, onInteractOutside: r, onDismiss: a, ...l } = e, d = wt(Tr), [s, m] = y(null), u = (o = s == null ? void 0 : s.ownerDocument) !== null && o !== void 0 ? o : globalThis == null ? void 0 : globalThis.document, [, C] = y({}), g = $(
    t,
    (Y) => m(Y)
  ), f = Array.from(d.layers), [h] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), p = f.indexOf(h), B = s ? f.indexOf(s) : -1, Q = d.layersWithOutsidePointerEventsDisabled.size > 0, v = B >= p, G = Vr((Y) => {
    const K = Y.target, P = [
      ...d.branches
    ].some(
      (R) => R.contains(K)
    );
    !v || P || (i == null || i(Y), r == null || r(Y), Y.defaultPrevented || a == null || a());
  }, u), q = zr((Y) => {
    const K = Y.target;
    [
      ...d.branches
    ].some(
      (R) => R.contains(K)
    ) || (c == null || c(Y), r == null || r(Y), Y.defaultPrevented || a == null || a());
  }, u);
  return Lr((Y) => {
    B === d.layers.size - 1 && (A == null || A(Y), !Y.defaultPrevented && a && (Y.preventDefault(), a()));
  }, u), L(() => {
    if (s)
      return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (mo = u.body.style.pointerEvents, u.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(s)), d.layers.add(s), ho(), () => {
        n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (u.body.style.pointerEvents = mo);
      };
  }, [
    s,
    u,
    n,
    d
  ]), L(() => () => {
    s && (d.layers.delete(s), d.layersWithOutsidePointerEventsDisabled.delete(s), ho());
  }, [
    s,
    d
  ]), L(() => {
    const Y = () => C({});
    return document.addEventListener(Ht, Y), () => document.removeEventListener(Ht, Y);
  }, []), /* @__PURE__ */ E(V.div, b({}, l, {
    ref: g,
    style: {
      pointerEvents: Q ? v ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: T(e.onFocusCapture, q.onFocusCapture),
    onBlurCapture: T(e.onBlurCapture, q.onBlurCapture),
    onPointerDownCapture: T(e.onPointerDownCapture, G.onPointerDownCapture)
  }));
});
function Vr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const o = Ie(e), n = k(!1), A = k(() => {
  });
  return L(() => {
    const i = (r) => {
      if (r.target && !n.current) {
        let l = function() {
          tn(Pr, o, a, {
            discrete: !0
          });
        };
        const a = {
          originalEvent: r
        };
        r.pointerType === "touch" ? (t.removeEventListener("click", A.current), A.current = l, t.addEventListener("click", A.current, {
          once: !0
        })) : l();
      } else
        t.removeEventListener("click", A.current);
      n.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", i), t.removeEventListener("click", A.current);
    };
  }, [
    t,
    o
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function zr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const o = Ie(e), n = k(!1);
  return L(() => {
    const A = (i) => {
      i.target && !n.current && tn(Nr, o, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", A), () => t.removeEventListener("focusin", A);
  }, [
    t,
    o
  ]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function ho() {
  const e = new CustomEvent(Ht);
  document.dispatchEvent(e);
}
function tn(e, t, o, { discrete: n }) {
  const A = o.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: o
  });
  t && A.addEventListener(e, t, {
    once: !0
  }), n ? _A(A, i) : A.dispatchEvent(i);
}
let xt = 0;
function on() {
  L(() => {
    var e, t;
    const o = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = o[0]) !== null && e !== void 0 ? e : fo()), document.body.insertAdjacentElement("beforeend", (t = o[1]) !== null && t !== void 0 ? t : fo()), xt++, () => {
      xt === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (n) => n.remove()
      ), xt--;
    };
  }, []);
}
function fo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Mt = "focusScope.autoFocusOnMount", Kt = "focusScope.autoFocusOnUnmount", po = {
  bubbles: !1,
  cancelable: !0
}, nn = /* @__PURE__ */ O((e, t) => {
  const { loop: o = !1, trapped: n = !1, onMountAutoFocus: A, onUnmountAutoFocus: i, ...c } = e, [r, a] = y(null), l = Ie(A), d = Ie(i), s = k(null), m = $(
    t,
    (g) => a(g)
  ), u = k({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  L(() => {
    if (n) {
      let g = function(B) {
        if (u.paused || !r)
          return;
        const Q = B.target;
        r.contains(Q) ? s.current = Q : ve(s.current, {
          select: !0
        });
      }, f = function(B) {
        if (u.paused || !r)
          return;
        const Q = B.relatedTarget;
        Q !== null && (r.contains(Q) || ve(s.current, {
          select: !0
        }));
      }, h = function(B) {
        if (document.activeElement === document.body)
          for (const v of B)
            v.removedNodes.length > 0 && ve(r);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", f);
      const p = new MutationObserver(h);
      return r && p.observe(r, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", f), p.disconnect();
      };
    }
  }, [
    n,
    r,
    u.paused
  ]), L(() => {
    if (r) {
      Bo.add(u);
      const g = document.activeElement;
      if (!r.contains(g)) {
        const h = new CustomEvent(Mt, po);
        r.addEventListener(Mt, l), r.dispatchEvent(h), h.defaultPrevented || (Xr(oc(An(r)), {
          select: !0
        }), document.activeElement === g && ve(r));
      }
      return () => {
        r.removeEventListener(Mt, l), setTimeout(() => {
          const h = new CustomEvent(Kt, po);
          r.addEventListener(Kt, d), r.dispatchEvent(h), h.defaultPrevented || ve(g ?? document.body, {
            select: !0
          }), r.removeEventListener(Kt, d), Bo.remove(u);
        }, 0);
      };
    }
  }, [
    r,
    l,
    d,
    u
  ]);
  const C = X((g) => {
    if (!o && !n || u.paused)
      return;
    const f = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, h = document.activeElement;
    if (f && h) {
      const p = g.currentTarget, [B, Q] = $r(p);
      B && Q ? !g.shiftKey && h === Q ? (g.preventDefault(), o && ve(B, {
        select: !0
      })) : g.shiftKey && h === B && (g.preventDefault(), o && ve(Q, {
        select: !0
      })) : h === p && g.preventDefault();
    }
  }, [
    o,
    n,
    u.paused
  ]);
  return /* @__PURE__ */ E(V.div, b({
    tabIndex: -1
  }, c, {
    ref: m,
    onKeyDown: C
  }));
});
function Xr(e, { select: t = !1 } = {}) {
  const o = document.activeElement;
  for (const n of e)
    if (ve(n, {
      select: t
    }), document.activeElement !== o)
      return;
}
function $r(e) {
  const t = An(e), o = Io(t, e), n = Io(t.reverse(), e);
  return [
    o,
    n
  ];
}
function An(e) {
  const t = [], o = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const A = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || A ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; o.nextNode(); )
    t.push(o.currentNode);
  return t;
}
function Io(e, t) {
  for (const o of e)
    if (!_r(o, {
      upTo: t
    }))
      return o;
}
function _r(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function ec(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ve(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const o = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== o && ec(e) && t && e.select();
  }
}
const Bo = tc();
function tc() {
  let e = [];
  return {
    add(t) {
      const o = e[0];
      t !== o && (o == null || o.pause()), e = wo(e, t), e.unshift(t);
    },
    remove(t) {
      var o;
      e = wo(e, t), (o = e[0]) === null || o === void 0 || o.resume();
    }
  };
}
function wo(e, t) {
  const o = [
    ...e
  ], n = o.indexOf(t);
  return n !== -1 && o.splice(n, 1), o;
}
function oc(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const oe = globalThis != null && globalThis.document ? Wo : () => {
}, nc = w.useId || (() => {
});
let Ac = 0;
function Yt(e) {
  const [t, o] = w.useState(nc());
  return oe(() => {
    e || o(
      (n) => n ?? String(Ac++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const ic = ["top", "right", "bottom", "left"], ge = Math.min, re = Math.max, ht = Math.round, At = Math.floor, qe = (e) => ({
  x: e,
  y: e
}), rc = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, cc = {
  start: "end",
  end: "start"
};
function jt(e, t, o) {
  return re(e, ge(t, o));
}
function Be(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function we(e) {
  return e.split("-")[0];
}
function Le(e) {
  return e.split("-")[1];
}
function $t(e) {
  return e === "x" ? "y" : "x";
}
function _t(e) {
  return e === "y" ? "height" : "width";
}
function Pe(e) {
  return ["top", "bottom"].includes(we(e)) ? "y" : "x";
}
function eo(e) {
  return $t(Pe(e));
}
function ac(e, t, o) {
  o === void 0 && (o = !1);
  const n = Le(e), A = eo(e), i = _t(A);
  let c = A === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (c = ft(c)), [c, ft(c)];
}
function lc(e) {
  const t = ft(e);
  return [Lt(e), t, Lt(t)];
}
function Lt(e) {
  return e.replace(/start|end/g, (t) => cc[t]);
}
function sc(e, t, o) {
  const n = ["left", "right"], A = ["right", "left"], i = ["top", "bottom"], c = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return o ? t ? A : n : t ? n : A;
    case "left":
    case "right":
      return t ? i : c;
    default:
      return [];
  }
}
function gc(e, t, o, n) {
  const A = Le(e);
  let i = sc(we(e), o === "start", n);
  return A && (i = i.map((c) => c + "-" + A), t && (i = i.concat(i.map(Lt)))), i;
}
function ft(e) {
  return e.replace(/left|right|bottom|top/g, (t) => rc[t]);
}
function dc(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function rn(e) {
  return typeof e != "number" ? dc(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function pt(e) {
  const {
    x: t,
    y: o,
    width: n,
    height: A
  } = e;
  return {
    width: n,
    height: A,
    top: o,
    left: t,
    right: t + n,
    bottom: o + A,
    x: t,
    y: o
  };
}
function Eo(e, t, o) {
  let {
    reference: n,
    floating: A
  } = e;
  const i = Pe(t), c = eo(t), r = _t(c), a = we(t), l = i === "y", d = n.x + n.width / 2 - A.width / 2, s = n.y + n.height / 2 - A.height / 2, m = n[r] / 2 - A[r] / 2;
  let u;
  switch (a) {
    case "top":
      u = {
        x: d,
        y: n.y - A.height
      };
      break;
    case "bottom":
      u = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      u = {
        x: n.x + n.width,
        y: s
      };
      break;
    case "left":
      u = {
        x: n.x - A.width,
        y: s
      };
      break;
    default:
      u = {
        x: n.x,
        y: n.y
      };
  }
  switch (Le(t)) {
    case "start":
      u[c] -= m * (o && l ? -1 : 1);
      break;
    case "end":
      u[c] += m * (o && l ? -1 : 1);
      break;
  }
  return u;
}
const uc = async (e, t, o) => {
  const {
    placement: n = "bottom",
    strategy: A = "absolute",
    middleware: i = [],
    platform: c
  } = o, r = i.filter(Boolean), a = await (c.isRTL == null ? void 0 : c.isRTL(t));
  let l = await c.getElementRects({
    reference: e,
    floating: t,
    strategy: A
  }), {
    x: d,
    y: s
  } = Eo(l, n, a), m = n, u = {}, C = 0;
  for (let g = 0; g < r.length; g++) {
    const {
      name: f,
      fn: h
    } = r[g], {
      x: p,
      y: B,
      data: Q,
      reset: v
    } = await h({
      x: d,
      y: s,
      initialPlacement: n,
      placement: m,
      strategy: A,
      middlewareData: u,
      rects: l,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = p ?? d, s = B ?? s, u = {
      ...u,
      [f]: {
        ...u[f],
        ...Q
      }
    }, v && C <= 50 && (C++, typeof v == "object" && (v.placement && (m = v.placement), v.rects && (l = v.rects === !0 ? await c.getElementRects({
      reference: e,
      floating: t,
      strategy: A
    }) : v.rects), {
      x: d,
      y: s
    } = Eo(l, m, a)), g = -1);
  }
  return {
    x: d,
    y: s,
    placement: m,
    strategy: A,
    middlewareData: u
  };
};
async function $e(e, t) {
  var o;
  t === void 0 && (t = {});
  const {
    x: n,
    y: A,
    platform: i,
    rects: c,
    elements: r,
    strategy: a
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: s = "floating",
    altBoundary: m = !1,
    padding: u = 0
  } = Be(t, e), C = rn(u), f = r[m ? s === "floating" ? "reference" : "floating" : s], h = pt(await i.getClippingRect({
    element: (o = await (i.isElement == null ? void 0 : i.isElement(f))) == null || o ? f : f.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(r.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: a
  })), p = s === "floating" ? {
    x: n,
    y: A,
    width: c.floating.width,
    height: c.floating.height
  } : c.reference, B = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(r.floating)), Q = await (i.isElement == null ? void 0 : i.isElement(B)) ? await (i.getScale == null ? void 0 : i.getScale(B)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, v = pt(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: r,
    rect: p,
    offsetParent: B,
    strategy: a
  }) : p);
  return {
    top: (h.top - v.top + C.top) / Q.y,
    bottom: (v.bottom - h.bottom + C.bottom) / Q.y,
    left: (h.left - v.left + C.left) / Q.x,
    right: (v.right - h.right + C.right) / Q.x
  };
}
const Cc = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: o,
      y: n,
      placement: A,
      rects: i,
      platform: c,
      elements: r,
      middlewareData: a
    } = t, {
      element: l,
      padding: d = 0
    } = Be(e, t) || {};
    if (l == null)
      return {};
    const s = rn(d), m = {
      x: o,
      y: n
    }, u = eo(A), C = _t(u), g = await c.getDimensions(l), f = u === "y", h = f ? "top" : "left", p = f ? "bottom" : "right", B = f ? "clientHeight" : "clientWidth", Q = i.reference[C] + i.reference[u] - m[u] - i.floating[C], v = m[u] - i.reference[u], G = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(l));
    let q = G ? G[B] : 0;
    (!q || !await (c.isElement == null ? void 0 : c.isElement(G))) && (q = r.floating[B] || i.floating[C]);
    const Y = Q / 2 - v / 2, K = q / 2 - g[C] / 2 - 1, P = ge(s[h], K), R = ge(s[p], K), x = P, z = q - g[C] - R, M = q / 2 - g[C] / 2 + Y, S = jt(x, M, z), U = !a.arrow && Le(A) != null && M !== S && i.reference[C] / 2 - (M < x ? P : R) - g[C] / 2 < 0, F = U ? M < x ? M - x : M - z : 0;
    return {
      [u]: m[u] + F,
      data: {
        [u]: S,
        centerOffset: M - S - F,
        ...U && {
          alignmentOffset: F
        }
      },
      reset: U
    };
  }
}), mc = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var o, n;
      const {
        placement: A,
        middlewareData: i,
        rects: c,
        initialPlacement: r,
        platform: a,
        elements: l
      } = t, {
        mainAxis: d = !0,
        crossAxis: s = !0,
        fallbackPlacements: m,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: C = "none",
        flipAlignment: g = !0,
        ...f
      } = Be(e, t);
      if ((o = i.arrow) != null && o.alignmentOffset)
        return {};
      const h = we(A), p = we(r) === r, B = await (a.isRTL == null ? void 0 : a.isRTL(l.floating)), Q = m || (p || !g ? [ft(r)] : lc(r));
      !m && C !== "none" && Q.push(...gc(r, g, C, B));
      const v = [r, ...Q], G = await $e(t, f), q = [];
      let Y = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (d && q.push(G[h]), s) {
        const x = ac(A, c, B);
        q.push(G[x[0]], G[x[1]]);
      }
      if (Y = [...Y, {
        placement: A,
        overflows: q
      }], !q.every((x) => x <= 0)) {
        var K, P;
        const x = (((K = i.flip) == null ? void 0 : K.index) || 0) + 1, z = v[x];
        if (z)
          return {
            data: {
              index: x,
              overflows: Y
            },
            reset: {
              placement: z
            }
          };
        let M = (P = Y.filter((S) => S.overflows[0] <= 0).sort((S, U) => S.overflows[1] - U.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!M)
          switch (u) {
            case "bestFit": {
              var R;
              const S = (R = Y.map((U) => [U.placement, U.overflows.filter((F) => F > 0).reduce((F, te) => F + te, 0)]).sort((U, F) => U[1] - F[1])[0]) == null ? void 0 : R[0];
              S && (M = S);
              break;
            }
            case "initialPlacement":
              M = r;
              break;
          }
        if (A !== M)
          return {
            reset: {
              placement: M
            }
          };
      }
      return {};
    }
  };
};
function Qo(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function vo(e) {
  return ic.some((t) => e[t] >= 0);
}
const hc = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: o
      } = t, {
        strategy: n = "referenceHidden",
        ...A
      } = Be(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await $e(t, {
            ...A,
            elementContext: "reference"
          }), c = Qo(i, o.reference);
          return {
            data: {
              referenceHiddenOffsets: c,
              referenceHidden: vo(c)
            }
          };
        }
        case "escaped": {
          const i = await $e(t, {
            ...A,
            altBoundary: !0
          }), c = Qo(i, o.floating);
          return {
            data: {
              escapedOffsets: c,
              escaped: vo(c)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function fc(e, t) {
  const {
    placement: o,
    platform: n,
    elements: A
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(A.floating)), c = we(o), r = Le(o), a = Pe(o) === "y", l = ["left", "top"].includes(c) ? -1 : 1, d = i && a ? -1 : 1, s = Be(t, e);
  let {
    mainAxis: m,
    crossAxis: u,
    alignmentAxis: C
  } = typeof s == "number" ? {
    mainAxis: s,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...s
  };
  return r && typeof C == "number" && (u = r === "end" ? C * -1 : C), a ? {
    x: u * d,
    y: m * l
  } : {
    x: m * l,
    y: u * d
  };
}
const pc = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var o, n;
      const {
        x: A,
        y: i,
        placement: c,
        middlewareData: r
      } = t, a = await fc(t, e);
      return c === ((o = r.offset) == null ? void 0 : o.placement) && (n = r.arrow) != null && n.alignmentOffset ? {} : {
        x: A + a.x,
        y: i + a.y,
        data: {
          ...a,
          placement: c
        }
      };
    }
  };
}, Ic = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: o,
        y: n,
        placement: A
      } = t, {
        mainAxis: i = !0,
        crossAxis: c = !1,
        limiter: r = {
          fn: (f) => {
            let {
              x: h,
              y: p
            } = f;
            return {
              x: h,
              y: p
            };
          }
        },
        ...a
      } = Be(e, t), l = {
        x: o,
        y: n
      }, d = await $e(t, a), s = Pe(we(A)), m = $t(s);
      let u = l[m], C = l[s];
      if (i) {
        const f = m === "y" ? "top" : "left", h = m === "y" ? "bottom" : "right", p = u + d[f], B = u - d[h];
        u = jt(p, u, B);
      }
      if (c) {
        const f = s === "y" ? "top" : "left", h = s === "y" ? "bottom" : "right", p = C + d[f], B = C - d[h];
        C = jt(p, C, B);
      }
      const g = r.fn({
        ...t,
        [m]: u,
        [s]: C
      });
      return {
        ...g,
        data: {
          x: g.x - o,
          y: g.y - n
        }
      };
    }
  };
}, Bc = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: o,
        y: n,
        placement: A,
        rects: i,
        middlewareData: c
      } = t, {
        offset: r = 0,
        mainAxis: a = !0,
        crossAxis: l = !0
      } = Be(e, t), d = {
        x: o,
        y: n
      }, s = Pe(A), m = $t(s);
      let u = d[m], C = d[s];
      const g = Be(r, t), f = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (a) {
        const B = m === "y" ? "height" : "width", Q = i.reference[m] - i.floating[B] + f.mainAxis, v = i.reference[m] + i.reference[B] - f.mainAxis;
        u < Q ? u = Q : u > v && (u = v);
      }
      if (l) {
        var h, p;
        const B = m === "y" ? "width" : "height", Q = ["top", "left"].includes(we(A)), v = i.reference[s] - i.floating[B] + (Q && ((h = c.offset) == null ? void 0 : h[s]) || 0) + (Q ? 0 : f.crossAxis), G = i.reference[s] + i.reference[B] + (Q ? 0 : ((p = c.offset) == null ? void 0 : p[s]) || 0) - (Q ? f.crossAxis : 0);
        C < v ? C = v : C > G && (C = G);
      }
      return {
        [m]: u,
        [s]: C
      };
    }
  };
}, wc = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: o,
        rects: n,
        platform: A,
        elements: i
      } = t, {
        apply: c = () => {
        },
        ...r
      } = Be(e, t), a = await $e(t, r), l = we(o), d = Le(o), s = Pe(o) === "y", {
        width: m,
        height: u
      } = n.floating;
      let C, g;
      l === "top" || l === "bottom" ? (C = l, g = d === (await (A.isRTL == null ? void 0 : A.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = l, C = d === "end" ? "top" : "bottom");
      const f = u - a.top - a.bottom, h = m - a.left - a.right, p = ge(u - a[C], f), B = ge(m - a[g], h), Q = !t.middlewareData.shift;
      let v = p, G = B;
      if (s ? G = d || Q ? ge(B, h) : h : v = d || Q ? ge(p, f) : f, Q && !d) {
        const Y = re(a.left, 0), K = re(a.right, 0), P = re(a.top, 0), R = re(a.bottom, 0);
        s ? G = m - 2 * (Y !== 0 || K !== 0 ? Y + K : re(a.left, a.right)) : v = u - 2 * (P !== 0 || R !== 0 ? P + R : re(a.top, a.bottom));
      }
      await c({
        ...t,
        availableWidth: G,
        availableHeight: v
      });
      const q = await A.getDimensions(i.floating);
      return m !== q.width || u !== q.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ne(e) {
  return cn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ce(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ee(e) {
  var t;
  return (t = (cn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function cn(e) {
  return e instanceof Node || e instanceof ce(e).Node;
}
function de(e) {
  return e instanceof Element || e instanceof ce(e).Element;
}
function ue(e) {
  return e instanceof HTMLElement || e instanceof ce(e).HTMLElement;
}
function Yo(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ce(e).ShadowRoot;
}
function tt(e) {
  const {
    overflow: t,
    overflowX: o,
    overflowY: n,
    display: A
  } = le(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + o) && !["inline", "contents"].includes(A);
}
function Ec(e) {
  return ["table", "td", "th"].includes(Ne(e));
}
function to(e) {
  const t = oo(), o = le(e);
  return o.transform !== "none" || o.perspective !== "none" || (o.containerType ? o.containerType !== "normal" : !1) || !t && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !t && (o.filter ? o.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (o.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (o.contain || "").includes(n));
}
function Qc(e) {
  let t = be(e);
  for (; ue(t) && !We(t); ) {
    if (to(t))
      return t;
    t = be(t);
  }
  return null;
}
function oo() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function We(e) {
  return ["html", "body", "#document"].includes(Ne(e));
}
function le(e) {
  return ce(e).getComputedStyle(e);
}
function qt(e) {
  return de(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function be(e) {
  if (Ne(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Yo(e) && e.host || // Fallback.
    Ee(e)
  );
  return Yo(t) ? t.host : t;
}
function an(e) {
  const t = be(e);
  return We(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ue(t) && tt(t) ? t : an(t);
}
function _e(e, t, o) {
  var n;
  t === void 0 && (t = []), o === void 0 && (o = !0);
  const A = an(e), i = A === ((n = e.ownerDocument) == null ? void 0 : n.body), c = ce(A);
  return i ? t.concat(c, c.visualViewport || [], tt(A) ? A : [], c.frameElement && o ? _e(c.frameElement) : []) : t.concat(A, _e(A, [], o));
}
function ln(e) {
  const t = le(e);
  let o = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const A = ue(e), i = A ? e.offsetWidth : o, c = A ? e.offsetHeight : n, r = ht(o) !== i || ht(n) !== c;
  return r && (o = i, n = c), {
    width: o,
    height: n,
    $: r
  };
}
function no(e) {
  return de(e) ? e : e.contextElement;
}
function ke(e) {
  const t = no(e);
  if (!ue(t))
    return qe(1);
  const o = t.getBoundingClientRect(), {
    width: n,
    height: A,
    $: i
  } = ln(t);
  let c = (i ? ht(o.width) : o.width) / n, r = (i ? ht(o.height) : o.height) / A;
  return (!c || !Number.isFinite(c)) && (c = 1), (!r || !Number.isFinite(r)) && (r = 1), {
    x: c,
    y: r
  };
}
const vc = /* @__PURE__ */ qe(0);
function sn(e) {
  const t = ce(e);
  return !oo() || !t.visualViewport ? vc : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Yc(e, t, o) {
  return t === void 0 && (t = !1), !o || t && o !== ce(e) ? !1 : t;
}
function Fe(e, t, o, n) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  const A = e.getBoundingClientRect(), i = no(e);
  let c = qe(1);
  t && (n ? de(n) && (c = ke(n)) : c = ke(e));
  const r = Yc(i, o, n) ? sn(i) : qe(0);
  let a = (A.left + r.x) / c.x, l = (A.top + r.y) / c.y, d = A.width / c.x, s = A.height / c.y;
  if (i) {
    const m = ce(i), u = n && de(n) ? ce(n) : n;
    let C = m, g = C.frameElement;
    for (; g && n && u !== C; ) {
      const f = ke(g), h = g.getBoundingClientRect(), p = le(g), B = h.left + (g.clientLeft + parseFloat(p.paddingLeft)) * f.x, Q = h.top + (g.clientTop + parseFloat(p.paddingTop)) * f.y;
      a *= f.x, l *= f.y, d *= f.x, s *= f.y, a += B, l += Q, C = ce(g), g = C.frameElement;
    }
  }
  return pt({
    width: d,
    height: s,
    x: a,
    y: l
  });
}
const qc = [":popover-open", ":modal"];
function Ao(e) {
  return qc.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function bc(e) {
  let {
    elements: t,
    rect: o,
    offsetParent: n,
    strategy: A
  } = e;
  const i = A === "fixed", c = Ee(n), r = t ? Ao(t.floating) : !1;
  if (n === c || r && i)
    return o;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = qe(1);
  const d = qe(0), s = ue(n);
  if ((s || !s && !i) && ((Ne(n) !== "body" || tt(c)) && (a = qt(n)), ue(n))) {
    const m = Fe(n);
    l = ke(n), d.x = m.x + n.clientLeft, d.y = m.y + n.clientTop;
  }
  return {
    width: o.width * l.x,
    height: o.height * l.y,
    x: o.x * l.x - a.scrollLeft * l.x + d.x,
    y: o.y * l.y - a.scrollTop * l.y + d.y
  };
}
function Dc(e) {
  return Array.from(e.getClientRects());
}
function gn(e) {
  return Fe(Ee(e)).left + qt(e).scrollLeft;
}
function Oc(e) {
  const t = Ee(e), o = qt(e), n = e.ownerDocument.body, A = re(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = re(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let c = -o.scrollLeft + gn(e);
  const r = -o.scrollTop;
  return le(n).direction === "rtl" && (c += re(t.clientWidth, n.clientWidth) - A), {
    width: A,
    height: i,
    x: c,
    y: r
  };
}
function Gc(e, t) {
  const o = ce(e), n = Ee(e), A = o.visualViewport;
  let i = n.clientWidth, c = n.clientHeight, r = 0, a = 0;
  if (A) {
    i = A.width, c = A.height;
    const l = oo();
    (!l || l && t === "fixed") && (r = A.offsetLeft, a = A.offsetTop);
  }
  return {
    width: i,
    height: c,
    x: r,
    y: a
  };
}
function Fc(e, t) {
  const o = Fe(e, !0, t === "fixed"), n = o.top + e.clientTop, A = o.left + e.clientLeft, i = ue(e) ? ke(e) : qe(1), c = e.clientWidth * i.x, r = e.clientHeight * i.y, a = A * i.x, l = n * i.y;
  return {
    width: c,
    height: r,
    x: a,
    y: l
  };
}
function qo(e, t, o) {
  let n;
  if (t === "viewport")
    n = Gc(e, o);
  else if (t === "document")
    n = Oc(Ee(e));
  else if (de(t))
    n = Fc(t, o);
  else {
    const A = sn(e);
    n = {
      ...t,
      x: t.x - A.x,
      y: t.y - A.y
    };
  }
  return pt(n);
}
function dn(e, t) {
  const o = be(e);
  return o === t || !de(o) || We(o) ? !1 : le(o).position === "fixed" || dn(o, t);
}
function Sc(e, t) {
  const o = t.get(e);
  if (o)
    return o;
  let n = _e(e, [], !1).filter((r) => de(r) && Ne(r) !== "body"), A = null;
  const i = le(e).position === "fixed";
  let c = i ? be(e) : e;
  for (; de(c) && !We(c); ) {
    const r = le(c), a = to(c);
    !a && r.position === "fixed" && (A = null), (i ? !a && !A : !a && r.position === "static" && !!A && ["absolute", "fixed"].includes(A.position) || tt(c) && !a && dn(e, c)) ? n = n.filter((d) => d !== c) : A = r, c = be(c);
  }
  return t.set(e, n), n;
}
function xc(e) {
  let {
    element: t,
    boundary: o,
    rootBoundary: n,
    strategy: A
  } = e;
  const c = [...o === "clippingAncestors" ? Ao(t) ? [] : Sc(t, this._c) : [].concat(o), n], r = c[0], a = c.reduce((l, d) => {
    const s = qo(t, d, A);
    return l.top = re(s.top, l.top), l.right = ge(s.right, l.right), l.bottom = ge(s.bottom, l.bottom), l.left = re(s.left, l.left), l;
  }, qo(t, r, A));
  return {
    width: a.right - a.left,
    height: a.bottom - a.top,
    x: a.left,
    y: a.top
  };
}
function Mc(e) {
  const {
    width: t,
    height: o
  } = ln(e);
  return {
    width: t,
    height: o
  };
}
function Kc(e, t, o) {
  const n = ue(t), A = Ee(t), i = o === "fixed", c = Fe(e, !0, i, t);
  let r = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = qe(0);
  if (n || !n && !i)
    if ((Ne(t) !== "body" || tt(A)) && (r = qt(t)), n) {
      const s = Fe(t, !0, i, t);
      a.x = s.x + t.clientLeft, a.y = s.y + t.clientTop;
    } else
      A && (a.x = gn(A));
  const l = c.left + r.scrollLeft - a.x, d = c.top + r.scrollTop - a.y;
  return {
    x: l,
    y: d,
    width: c.width,
    height: c.height
  };
}
function yt(e) {
  return le(e).position === "static";
}
function bo(e, t) {
  return !ue(e) || le(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function un(e, t) {
  const o = ce(e);
  if (Ao(e))
    return o;
  if (!ue(e)) {
    let A = be(e);
    for (; A && !We(A); ) {
      if (de(A) && !yt(A))
        return A;
      A = be(A);
    }
    return o;
  }
  let n = bo(e, t);
  for (; n && Ec(n) && yt(n); )
    n = bo(n, t);
  return n && We(n) && yt(n) && !to(n) ? o : n || Qc(e) || o;
}
const yc = async function(e) {
  const t = this.getOffsetParent || un, o = this.getDimensions, n = await o(e.floating);
  return {
    reference: Kc(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Jc(e) {
  return le(e).direction === "rtl";
}
const Zc = {
  convertOffsetParentRelativeRectToViewportRelativeRect: bc,
  getDocumentElement: Ee,
  getClippingRect: xc,
  getOffsetParent: un,
  getElementRects: yc,
  getClientRects: Dc,
  getDimensions: Mc,
  getScale: ke,
  isElement: de,
  isRTL: Jc
};
function kc(e, t) {
  let o = null, n;
  const A = Ee(e);
  function i() {
    var r;
    clearTimeout(n), (r = o) == null || r.disconnect(), o = null;
  }
  function c(r, a) {
    r === void 0 && (r = !1), a === void 0 && (a = 1), i();
    const {
      left: l,
      top: d,
      width: s,
      height: m
    } = e.getBoundingClientRect();
    if (r || t(), !s || !m)
      return;
    const u = At(d), C = At(A.clientWidth - (l + s)), g = At(A.clientHeight - (d + m)), f = At(l), p = {
      rootMargin: -u + "px " + -C + "px " + -g + "px " + -f + "px",
      threshold: re(0, ge(1, a)) || 1
    };
    let B = !0;
    function Q(v) {
      const G = v[0].intersectionRatio;
      if (G !== a) {
        if (!B)
          return c();
        G ? c(!1, G) : n = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      B = !1;
    }
    try {
      o = new IntersectionObserver(Q, {
        ...p,
        // Handle <iframe>s
        root: A.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(Q, p);
    }
    o.observe(e);
  }
  return c(!0), i;
}
function Uc(e, t, o, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: A = !0,
    ancestorResize: i = !0,
    elementResize: c = typeof ResizeObserver == "function",
    layoutShift: r = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = n, l = no(e), d = A || i ? [...l ? _e(l) : [], ..._e(t)] : [];
  d.forEach((h) => {
    A && h.addEventListener("scroll", o, {
      passive: !0
    }), i && h.addEventListener("resize", o);
  });
  const s = l && r ? kc(l, o) : null;
  let m = -1, u = null;
  c && (u = new ResizeObserver((h) => {
    let [p] = h;
    p && p.target === l && u && (u.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var B;
      (B = u) == null || B.observe(t);
    })), o();
  }), l && !a && u.observe(l), u.observe(t));
  let C, g = a ? Fe(e) : null;
  a && f();
  function f() {
    const h = Fe(e);
    g && (h.x !== g.x || h.y !== g.y || h.width !== g.width || h.height !== g.height) && o(), g = h, C = requestAnimationFrame(f);
  }
  return o(), () => {
    var h;
    d.forEach((p) => {
      A && p.removeEventListener("scroll", o), i && p.removeEventListener("resize", o);
    }), s == null || s(), (h = u) == null || h.disconnect(), u = null, a && cancelAnimationFrame(C);
  };
}
const Rc = pc, Wc = Ic, Hc = mc, jc = wc, Lc = hc, Do = Cc, Pc = Bc, Nc = (e, t, o) => {
  const n = /* @__PURE__ */ new Map(), A = {
    platform: Zc,
    ...o
  }, i = {
    ...A.platform,
    _c: n
  };
  return uc(e, t, {
    ...A,
    platform: i
  });
};
var gt = typeof document < "u" ? Wo : L;
function It(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let o, n, A;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (o = e.length, o !== t.length)
        return !1;
      for (n = o; n-- !== 0; )
        if (!It(e[n], t[n]))
          return !1;
      return !0;
    }
    if (A = Object.keys(e), o = A.length, o !== Object.keys(t).length)
      return !1;
    for (n = o; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, A[n]))
        return !1;
    for (n = o; n-- !== 0; ) {
      const i = A[n];
      if (!(i === "_owner" && e.$$typeof) && !It(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Cn(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Oo(e, t) {
  const o = Cn(e);
  return Math.round(t * o) / o;
}
function Go(e) {
  const t = w.useRef(e);
  return gt(() => {
    t.current = e;
  }), t;
}
function Tc(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: o = "absolute",
    middleware: n = [],
    platform: A,
    elements: {
      reference: i,
      floating: c
    } = {},
    transform: r = !0,
    whileElementsMounted: a,
    open: l
  } = e, [d, s] = w.useState({
    x: 0,
    y: 0,
    strategy: o,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, u] = w.useState(n);
  It(m, n) || u(n);
  const [C, g] = w.useState(null), [f, h] = w.useState(null), p = w.useCallback((F) => {
    F !== G.current && (G.current = F, g(F));
  }, []), B = w.useCallback((F) => {
    F !== q.current && (q.current = F, h(F));
  }, []), Q = i || C, v = c || f, G = w.useRef(null), q = w.useRef(null), Y = w.useRef(d), K = a != null, P = Go(a), R = Go(A), x = w.useCallback(() => {
    if (!G.current || !q.current)
      return;
    const F = {
      placement: t,
      strategy: o,
      middleware: m
    };
    R.current && (F.platform = R.current), Nc(G.current, q.current, F).then((te) => {
      const _ = {
        ...te,
        isPositioned: !0
      };
      z.current && !It(Y.current, _) && (Y.current = _, xA.flushSync(() => {
        s(_);
      }));
    });
  }, [m, t, o, R]);
  gt(() => {
    l === !1 && Y.current.isPositioned && (Y.current.isPositioned = !1, s((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [l]);
  const z = w.useRef(!1);
  gt(() => (z.current = !0, () => {
    z.current = !1;
  }), []), gt(() => {
    if (Q && (G.current = Q), v && (q.current = v), Q && v) {
      if (P.current)
        return P.current(Q, v, x);
      x();
    }
  }, [Q, v, x, P, K]);
  const M = w.useMemo(() => ({
    reference: G,
    floating: q,
    setReference: p,
    setFloating: B
  }), [p, B]), S = w.useMemo(() => ({
    reference: Q,
    floating: v
  }), [Q, v]), U = w.useMemo(() => {
    const F = {
      position: o,
      left: 0,
      top: 0
    };
    if (!S.floating)
      return F;
    const te = Oo(S.floating, d.x), _ = Oo(S.floating, d.y);
    return r ? {
      ...F,
      transform: "translate(" + te + "px, " + _ + "px)",
      ...Cn(S.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: o,
      left: te,
      top: _
    };
  }, [o, r, S.floating, d.x, d.y]);
  return w.useMemo(() => ({
    ...d,
    update: x,
    refs: M,
    elements: S,
    floatingStyles: U
  }), [d, x, M, S, U]);
}
const Vc = (e) => {
  function t(o) {
    return {}.hasOwnProperty.call(o, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(o) {
      const {
        element: n,
        padding: A
      } = typeof e == "function" ? e(o) : e;
      return n && t(n) ? n.current != null ? Do({
        element: n.current,
        padding: A
      }).fn(o) : {} : n ? Do({
        element: n,
        padding: A
      }).fn(o) : {};
    }
  };
}, zc = (e, t) => ({
  ...Rc(e),
  options: [e, t]
}), Xc = (e, t) => ({
  ...Wc(e),
  options: [e, t]
}), $c = (e, t) => ({
  ...Pc(e),
  options: [e, t]
}), _c = (e, t) => ({
  ...Hc(e),
  options: [e, t]
}), ea = (e, t) => ({
  ...jc(e),
  options: [e, t]
}), ta = (e, t) => ({
  ...Lc(e),
  options: [e, t]
}), oa = (e, t) => ({
  ...Vc(e),
  options: [e, t]
}), na = /* @__PURE__ */ O((e, t) => {
  const { children: o, width: n = 10, height: A = 5, ...i } = e;
  return /* @__PURE__ */ E(V.svg, b({}, i, {
    ref: t,
    width: n,
    height: A,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? o : /* @__PURE__ */ E("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), Aa = na;
function ia(e) {
  const [t, o] = y(void 0);
  return oe(() => {
    if (e) {
      o({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const n = new ResizeObserver((A) => {
        if (!Array.isArray(A) || !A.length)
          return;
        const i = A[0];
        let c, r;
        if ("borderBoxSize" in i) {
          const a = i.borderBoxSize, l = Array.isArray(a) ? a[0] : a;
          c = l.inlineSize, r = l.blockSize;
        } else
          c = e.offsetWidth, r = e.offsetHeight;
        o({
          width: c,
          height: r
        });
      });
      return n.observe(e, {
        box: "border-box"
      }), () => n.unobserve(e);
    } else
      o(void 0);
  }, [
    e
  ]), t;
}
const mn = "Popper", [hn, bt] = vt(mn), [ra, fn] = hn(mn), ca = (e) => {
  const { __scopePopper: t, children: o } = e, [n, A] = y(null);
  return /* @__PURE__ */ E(ra, {
    scope: t,
    anchor: n,
    onAnchorChange: A
  }, o);
}, aa = "PopperAnchor", la = /* @__PURE__ */ O((e, t) => {
  const { __scopePopper: o, virtualRef: n, ...A } = e, i = fn(aa, o), c = k(null), r = $(t, c);
  return L(() => {
    i.onAnchorChange((n == null ? void 0 : n.current) || c.current);
  }), n ? null : /* @__PURE__ */ E(V.div, b({}, A, {
    ref: r
  }));
}), pn = "PopperContent", [sa, ga] = hn(pn), da = /* @__PURE__ */ O((e, t) => {
  var o, n, A, i, c, r, a, l;
  const { __scopePopper: d, side: s = "bottom", sideOffset: m = 0, align: u = "center", alignOffset: C = 0, arrowPadding: g = 0, avoidCollisions: f = !0, collisionBoundary: h = [], collisionPadding: p = 0, sticky: B = "partial", hideWhenDetached: Q = !1, updatePositionStrategy: v = "optimized", onPlaced: G, ...q } = e, Y = fn(pn, d), [K, P] = y(null), R = $(
    t,
    (he) => P(he)
  ), [x, z] = y(null), M = ia(x), S = (o = M == null ? void 0 : M.width) !== null && o !== void 0 ? o : 0, U = (n = M == null ? void 0 : M.height) !== null && n !== void 0 ? n : 0, F = s + (u !== "center" ? "-" + u : ""), te = typeof p == "number" ? p : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...p
  }, _ = Array.isArray(h) ? h : [
    h
  ], Ve = _.length > 0, Ce = {
    padding: te,
    boundary: _.filter(ha),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: Ve
  }, { refs: ze, floatingStyles: xe, placement: Qe, isPositioned: me, middlewareData: ae } = Tc({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: F,
    whileElementsMounted: (...he) => Uc(...he, {
      animationFrame: v === "always"
    }),
    elements: {
      reference: Y.anchor
    },
    middleware: [
      zc({
        mainAxis: m + U,
        alignmentAxis: C
      }),
      f && Xc({
        mainAxis: !0,
        crossAxis: !1,
        limiter: B === "partial" ? $c() : void 0,
        ...Ce
      }),
      f && _c({
        ...Ce
      }),
      ea({
        ...Ce,
        apply: ({ elements: he, rects: Me, availableWidth: Xe, availableHeight: bA }) => {
          const { width: DA, height: OA } = Me.reference, nt = he.floating.style;
          nt.setProperty("--radix-popper-available-width", `${Xe}px`), nt.setProperty("--radix-popper-available-height", `${bA}px`), nt.setProperty("--radix-popper-anchor-width", `${DA}px`), nt.setProperty("--radix-popper-anchor-height", `${OA}px`);
        }
      }),
      x && oa({
        element: x,
        padding: g
      }),
      fa({
        arrowWidth: S,
        arrowHeight: U
      }),
      Q && ta({
        strategy: "referenceHidden",
        ...Ce
      })
    ]
  }), [D, W] = In(Qe), ee = Ie(G);
  oe(() => {
    me && (ee == null || ee());
  }, [
    me,
    ee
  ]);
  const H = (A = ae.arrow) === null || A === void 0 ? void 0 : A.x, J = (i = ae.arrow) === null || i === void 0 ? void 0 : i.y, Z = ((c = ae.arrow) === null || c === void 0 ? void 0 : c.centerOffset) !== 0, [ne, Ae] = y();
  return oe(() => {
    K && Ae(window.getComputedStyle(K).zIndex);
  }, [
    K
  ]), /* @__PURE__ */ E("div", {
    ref: ze.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...xe,
      transform: me ? xe.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ne,
      "--radix-popper-transform-origin": [
        (r = ae.transformOrigin) === null || r === void 0 ? void 0 : r.x,
        (a = ae.transformOrigin) === null || a === void 0 ? void 0 : a.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ E(sa, {
    scope: d,
    placedSide: D,
    onArrowChange: z,
    arrowX: H,
    arrowY: J,
    shouldHideArrow: Z
  }, /* @__PURE__ */ E(V.div, b({
    "data-side": D,
    "data-align": W
  }, q, {
    ref: R,
    style: {
      ...q.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: me ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = ae.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
}), ua = "PopperArrow", Ca = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ma = /* @__PURE__ */ O(function(t, o) {
  const { __scopePopper: n, ...A } = t, i = ga(ua, n), c = Ca[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ E("span", {
      ref: i.onArrowChange,
      style: {
        position: "absolute",
        left: i.arrowX,
        top: i.arrowY,
        [c]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[i.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[i.placedSide],
        visibility: i.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ E(Aa, b({}, A, {
      ref: o,
      style: {
        ...A.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function ha(e) {
  return e !== null;
}
const fa = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var o, n, A, i, c;
    const { placement: r, rects: a, middlewareData: l } = t, s = ((o = l.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, m = s ? 0 : e.arrowWidth, u = s ? 0 : e.arrowHeight, [C, g] = In(r), f = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], h = ((n = (A = l.arrow) === null || A === void 0 ? void 0 : A.x) !== null && n !== void 0 ? n : 0) + m / 2, p = ((i = (c = l.arrow) === null || c === void 0 ? void 0 : c.y) !== null && i !== void 0 ? i : 0) + u / 2;
    let B = "", Q = "";
    return C === "bottom" ? (B = s ? f : `${h}px`, Q = `${-u}px`) : C === "top" ? (B = s ? f : `${h}px`, Q = `${a.floating.height + u}px`) : C === "right" ? (B = `${-u}px`, Q = s ? f : `${p}px`) : C === "left" && (B = `${a.floating.width + u}px`, Q = s ? f : `${p}px`), {
      data: {
        x: B,
        y: Q
      }
    };
  }
});
function In(e) {
  const [t, o = "center"] = e.split("-");
  return [
    t,
    o
  ];
}
const Bn = ca, io = la, wn = da, En = ma, Qn = /* @__PURE__ */ O((e, t) => {
  var o;
  const { container: n = globalThis == null || (o = globalThis.document) === null || o === void 0 ? void 0 : o.body, ...A } = e;
  return n ? /* @__PURE__ */ MA.createPortal(/* @__PURE__ */ E(V.div, b({}, A, {
    ref: t
  })), n) : null;
});
function Pt({ prop: e, defaultProp: t, onChange: o = () => {
} }) {
  const [n, A] = pa({
    defaultProp: t,
    onChange: o
  }), i = e !== void 0, c = i ? e : n, r = Ie(o), a = X((l) => {
    if (i) {
      const s = typeof l == "function" ? l(e) : l;
      s !== e && r(s);
    } else
      A(l);
  }, [
    i,
    e,
    A,
    r
  ]);
  return [
    c,
    a
  ];
}
function pa({ defaultProp: e, onChange: t }) {
  const o = y(e), [n] = o, A = k(n), i = Ie(t);
  return L(() => {
    A.current !== n && (i(n), A.current = n);
  }, [
    n,
    A,
    i
  ]), o;
}
function Ia(e) {
  const t = k({
    value: e,
    previous: e
  });
  return N(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const Ba = /* @__PURE__ */ O((e, t) => /* @__PURE__ */ E(V.span, b({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
})));
var wa = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Ke = /* @__PURE__ */ new WeakMap(), it = /* @__PURE__ */ new WeakMap(), rt = {}, Jt = 0, vn = function(e) {
  return e && (e.host || vn(e.parentNode));
}, Ea = function(e, t) {
  return t.map(function(o) {
    if (e.contains(o))
      return o;
    var n = vn(o);
    return n && e.contains(n) ? n : (console.error("aria-hidden", o, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(o) {
    return !!o;
  });
}, Qa = function(e, t, o, n) {
  var A = Ea(t, Array.isArray(e) ? e : [e]);
  rt[o] || (rt[o] = /* @__PURE__ */ new WeakMap());
  var i = rt[o], c = [], r = /* @__PURE__ */ new Set(), a = new Set(A), l = function(s) {
    !s || r.has(s) || (r.add(s), l(s.parentNode));
  };
  A.forEach(l);
  var d = function(s) {
    !s || a.has(s) || Array.prototype.forEach.call(s.children, function(m) {
      if (r.has(m))
        d(m);
      else
        try {
          var u = m.getAttribute(n), C = u !== null && u !== "false", g = (Ke.get(m) || 0) + 1, f = (i.get(m) || 0) + 1;
          Ke.set(m, g), i.set(m, f), c.push(m), g === 1 && C && it.set(m, !0), f === 1 && m.setAttribute(o, "true"), C || m.setAttribute(n, "true");
        } catch (h) {
          console.error("aria-hidden: cannot operate on ", m, h);
        }
    });
  };
  return d(t), r.clear(), Jt++, function() {
    c.forEach(function(s) {
      var m = Ke.get(s) - 1, u = i.get(s) - 1;
      Ke.set(s, m), i.set(s, u), m || (it.has(s) || s.removeAttribute(n), it.delete(s)), u || s.removeAttribute(o);
    }), Jt--, Jt || (Ke = /* @__PURE__ */ new WeakMap(), Ke = /* @__PURE__ */ new WeakMap(), it = /* @__PURE__ */ new WeakMap(), rt = {});
  };
}, Yn = function(e, t, o) {
  o === void 0 && (o = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), A = wa(e);
  return A ? (n.push.apply(n, Array.from(A.querySelectorAll("[aria-live]"))), Qa(n, A, o, "aria-hidden")) : function() {
    return null;
  };
}, se = function() {
  return se = Object.assign || function(t) {
    for (var o, n = 1, A = arguments.length; n < A; n++) {
      o = arguments[n];
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (t[i] = o[i]);
    }
    return t;
  }, se.apply(this, arguments);
};
function qn(e, t) {
  var o = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var A = 0, n = Object.getOwnPropertySymbols(e); A < n.length; A++)
      t.indexOf(n[A]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[A]) && (o[n[A]] = e[n[A]]);
  return o;
}
function va(e, t, o) {
  if (o || arguments.length === 2)
    for (var n = 0, A = t.length, i; n < A; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var dt = "right-scroll-bar-position", ut = "width-before-scroll-bar", Ya = "with-scroll-bars-hidden", qa = "--removed-body-scroll-bar-size";
function Zt(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function ba(e, t) {
  var o = y(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return o.value;
        },
        set current(n) {
          var A = o.value;
          A !== n && (o.value = n, o.callback(n, A));
        }
      }
    };
  })[0];
  return o.callback = t, o.facade;
}
var Da = typeof window < "u" ? w.useLayoutEffect : w.useEffect, Fo = /* @__PURE__ */ new WeakMap();
function Oa(e, t) {
  var o = ba(null, function(n) {
    return e.forEach(function(A) {
      return Zt(A, n);
    });
  });
  return Da(function() {
    var n = Fo.get(o);
    if (n) {
      var A = new Set(n), i = new Set(e), c = o.current;
      A.forEach(function(r) {
        i.has(r) || Zt(r, null);
      }), i.forEach(function(r) {
        A.has(r) || Zt(r, c);
      });
    }
    Fo.set(o, e);
  }, [e]), o;
}
function Ga(e) {
  return e;
}
function Fa(e, t) {
  t === void 0 && (t = Ga);
  var o = [], n = !1, A = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return o.length ? o[o.length - 1] : e;
    },
    useMedium: function(i) {
      var c = t(i, n);
      return o.push(c), function() {
        o = o.filter(function(r) {
          return r !== c;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; o.length; ) {
        var c = o;
        o = [], c.forEach(i);
      }
      o = {
        push: function(r) {
          return i(r);
        },
        filter: function() {
          return o;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var c = [];
      if (o.length) {
        var r = o;
        o = [], r.forEach(i), c = o;
      }
      var a = function() {
        var d = c;
        c = [], d.forEach(i);
      }, l = function() {
        return Promise.resolve().then(a);
      };
      l(), o = {
        push: function(d) {
          c.push(d), l();
        },
        filter: function(d) {
          return c = c.filter(d), o;
        }
      };
    }
  };
  return A;
}
function Sa(e) {
  e === void 0 && (e = {});
  var t = Fa(null);
  return t.options = se({ async: !0, ssr: !1 }, e), t;
}
var bn = function(e) {
  var t = e.sideCar, o = qn(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return w.createElement(n, se({}, o));
};
bn.isSideCarExport = !0;
function xa(e, t) {
  return e.useMedium(t), bn;
}
var Dn = Sa(), kt = function() {
}, Dt = w.forwardRef(function(e, t) {
  var o = w.useRef(null), n = w.useState({
    onScrollCapture: kt,
    onWheelCapture: kt,
    onTouchMoveCapture: kt
  }), A = n[0], i = n[1], c = e.forwardProps, r = e.children, a = e.className, l = e.removeScrollBar, d = e.enabled, s = e.shards, m = e.sideCar, u = e.noIsolation, C = e.inert, g = e.allowPinchZoom, f = e.as, h = f === void 0 ? "div" : f, p = qn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), B = m, Q = Oa([o, t]), v = se(se({}, p), A);
  return w.createElement(
    w.Fragment,
    null,
    d && w.createElement(B, { sideCar: Dn, removeScrollBar: l, shards: s, noIsolation: u, inert: C, setCallbacks: i, allowPinchZoom: !!g, lockRef: o }),
    c ? w.cloneElement(w.Children.only(r), se(se({}, v), { ref: Q })) : w.createElement(h, se({}, v, { className: a, ref: Q }), r)
  );
});
Dt.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Dt.classNames = {
  fullWidth: ut,
  zeroRight: dt
};
var Ma = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Ka() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ma();
  return t && e.setAttribute("nonce", t), e;
}
function ya(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Ja(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Za = function() {
  var e = 0, t = null;
  return {
    add: function(o) {
      e == 0 && (t = Ka()) && (ya(t, o), Ja(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, ka = function() {
  var e = Za();
  return function(t, o) {
    w.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && o]);
  };
}, On = function() {
  var e = ka(), t = function(o) {
    var n = o.styles, A = o.dynamic;
    return e(n, A), null;
  };
  return t;
}, Ua = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Ut = function(e) {
  return parseInt(e || "", 10) || 0;
}, Ra = function(e) {
  var t = window.getComputedStyle(document.body), o = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], A = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Ut(o), Ut(n), Ut(A)];
}, Wa = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Ua;
  var t = Ra(e), o = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - o + t[2] - t[0])
  };
}, Ha = On(), Ue = "data-scroll-locked", ja = function(e, t, o, n) {
  var A = e.left, i = e.top, c = e.right, r = e.gap;
  return o === void 0 && (o = "margin"), `
  .`.concat(Ya, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(r, "px ").concat(n, `;
  }
  body[`).concat(Ue, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    o === "margin" && `
    padding-left: `.concat(A, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(c, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(r, "px ").concat(n, `;
    `),
    o === "padding" && "padding-right: ".concat(r, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(dt, ` {
    right: `).concat(r, "px ").concat(n, `;
  }
  
  .`).concat(ut, ` {
    margin-right: `).concat(r, "px ").concat(n, `;
  }
  
  .`).concat(dt, " .").concat(dt, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(ut, " .").concat(ut, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(Ue, `] {
    `).concat(qa, ": ").concat(r, `px;
  }
`);
}, So = function() {
  var e = parseInt(document.body.getAttribute(Ue) || "0", 10);
  return isFinite(e) ? e : 0;
}, La = function() {
  w.useEffect(function() {
    return document.body.setAttribute(Ue, (So() + 1).toString()), function() {
      var e = So() - 1;
      e <= 0 ? document.body.removeAttribute(Ue) : document.body.setAttribute(Ue, e.toString());
    };
  }, []);
}, Pa = function(e) {
  var t = e.noRelative, o = e.noImportant, n = e.gapMode, A = n === void 0 ? "margin" : n;
  La();
  var i = w.useMemo(function() {
    return Wa(A);
  }, [A]);
  return w.createElement(Ha, { styles: ja(i, !t, A, o ? "" : "!important") });
}, Nt = !1;
if (typeof window < "u")
  try {
    var ct = Object.defineProperty({}, "passive", {
      get: function() {
        return Nt = !0, !0;
      }
    });
    window.addEventListener("test", ct, ct), window.removeEventListener("test", ct, ct);
  } catch {
    Nt = !1;
  }
var ye = Nt ? { passive: !1 } : !1, Na = function(e) {
  return e.tagName === "TEXTAREA";
}, Gn = function(e, t) {
  var o = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    o[t] !== "hidden" && // contains scroll inside self
    !(o.overflowY === o.overflowX && !Na(e) && o[t] === "visible")
  );
}, Ta = function(e) {
  return Gn(e, "overflowY");
}, Va = function(e) {
  return Gn(e, "overflowX");
}, xo = function(e, t) {
  var o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var n = Fn(e, o);
    if (n) {
      var A = Sn(e, o), i = A[1], c = A[2];
      if (i > c)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== document.body);
  return !1;
}, za = function(e) {
  var t = e.scrollTop, o = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    o,
    n
  ];
}, Xa = function(e) {
  var t = e.scrollLeft, o = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    o,
    n
  ];
}, Fn = function(e, t) {
  return e === "v" ? Ta(t) : Va(t);
}, Sn = function(e, t) {
  return e === "v" ? za(t) : Xa(t);
}, $a = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, _a = function(e, t, o, n, A) {
  var i = $a(e, window.getComputedStyle(t).direction), c = i * n, r = o.target, a = t.contains(r), l = !1, d = c > 0, s = 0, m = 0;
  do {
    var u = Sn(e, r), C = u[0], g = u[1], f = u[2], h = g - f - i * C;
    (C || h) && Fn(e, r) && (s += h, m += C), r = r.parentNode;
  } while (
    // portaled content
    !a && r !== document.body || // self content
    a && (t.contains(r) || t === r)
  );
  return (d && (s === 0 || !A) || !d && (m === 0 || !A)) && (l = !0), l;
}, at = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Mo = function(e) {
  return [e.deltaX, e.deltaY];
}, Ko = function(e) {
  return e && "current" in e ? e.current : e;
}, el = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, tl = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ol = 0, Je = [];
function nl(e) {
  var t = w.useRef([]), o = w.useRef([0, 0]), n = w.useRef(), A = w.useState(ol++)[0], i = w.useState(function() {
    return On();
  })[0], c = w.useRef(e);
  w.useEffect(function() {
    c.current = e;
  }, [e]), w.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(A));
      var g = va([e.lockRef.current], (e.shards || []).map(Ko), !0).filter(Boolean);
      return g.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(A));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(A)), g.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(A));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var r = w.useCallback(function(g, f) {
    if ("touches" in g && g.touches.length === 2)
      return !c.current.allowPinchZoom;
    var h = at(g), p = o.current, B = "deltaX" in g ? g.deltaX : p[0] - h[0], Q = "deltaY" in g ? g.deltaY : p[1] - h[1], v, G = g.target, q = Math.abs(B) > Math.abs(Q) ? "h" : "v";
    if ("touches" in g && q === "h" && G.type === "range")
      return !1;
    var Y = xo(q, G);
    if (!Y)
      return !0;
    if (Y ? v = q : (v = q === "v" ? "h" : "v", Y = xo(q, G)), !Y)
      return !1;
    if (!n.current && "changedTouches" in g && (B || Q) && (n.current = v), !v)
      return !0;
    var K = n.current || v;
    return _a(K, f, g, K === "h" ? B : Q, !0);
  }, []), a = w.useCallback(function(g) {
    var f = g;
    if (!(!Je.length || Je[Je.length - 1] !== i)) {
      var h = "deltaY" in f ? Mo(f) : at(f), p = t.current.filter(function(v) {
        return v.name === f.type && v.target === f.target && el(v.delta, h);
      })[0];
      if (p && p.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!p) {
        var B = (c.current.shards || []).map(Ko).filter(Boolean).filter(function(v) {
          return v.contains(f.target);
        }), Q = B.length > 0 ? r(f, B[0]) : !c.current.noIsolation;
        Q && f.cancelable && f.preventDefault();
      }
    }
  }, []), l = w.useCallback(function(g, f, h, p) {
    var B = { name: g, delta: f, target: h, should: p };
    t.current.push(B), setTimeout(function() {
      t.current = t.current.filter(function(Q) {
        return Q !== B;
      });
    }, 1);
  }, []), d = w.useCallback(function(g) {
    o.current = at(g), n.current = void 0;
  }, []), s = w.useCallback(function(g) {
    l(g.type, Mo(g), g.target, r(g, e.lockRef.current));
  }, []), m = w.useCallback(function(g) {
    l(g.type, at(g), g.target, r(g, e.lockRef.current));
  }, []);
  w.useEffect(function() {
    return Je.push(i), e.setCallbacks({
      onScrollCapture: s,
      onWheelCapture: s,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", a, ye), document.addEventListener("touchmove", a, ye), document.addEventListener("touchstart", d, ye), function() {
      Je = Je.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", a, ye), document.removeEventListener("touchmove", a, ye), document.removeEventListener("touchstart", d, ye);
    };
  }, []);
  var u = e.removeScrollBar, C = e.inert;
  return w.createElement(
    w.Fragment,
    null,
    C ? w.createElement(i, { styles: tl(A) }) : null,
    u ? w.createElement(Pa, { gapMode: "margin" }) : null
  );
}
const Al = xa(Dn, nl);
var ro = w.forwardRef(function(e, t) {
  return w.createElement(Dt, se({}, e, { ref: t, sideCar: Al }));
});
ro.classNames = Dt.classNames;
const il = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], rl = [
  " ",
  "Enter"
], Ot = "Select", [Gt, Ft, cl] = Wr(Ot), [Te, al] = vt(Ot, [
  cl,
  bt
]), St = bt(), [ll, De] = Te(Ot), [sl, gl] = Te(Ot), xn = (e) => {
  const { __scopeSelect: t, children: o, open: n, defaultOpen: A, onOpenChange: i, value: c, defaultValue: r, onValueChange: a, dir: l, name: d, autoComplete: s, disabled: m, required: u } = e, C = St(t), [g, f] = y(null), [h, p] = y(null), [B, Q] = y(!1), v = jr(l), [G = !1, q] = Pt({
    prop: n,
    defaultProp: A,
    onChange: i
  }), [Y, K] = Pt({
    prop: c,
    defaultProp: r,
    onChange: a
  }), P = k(null), R = g ? !!g.closest("form") : !0, [x, z] = y(/* @__PURE__ */ new Set()), M = Array.from(x).map(
    (S) => S.props.value
  ).join(";");
  return /* @__PURE__ */ E(Bn, C, /* @__PURE__ */ E(ll, {
    required: u,
    scope: t,
    trigger: g,
    onTriggerChange: f,
    valueNode: h,
    onValueNodeChange: p,
    valueNodeHasChildren: B,
    onValueNodeHasChildrenChange: Q,
    contentId: Yt(),
    value: Y,
    onValueChange: K,
    open: G,
    onOpenChange: q,
    dir: v,
    triggerPointerDownPosRef: P,
    disabled: m
  }, /* @__PURE__ */ E(Gt.Provider, {
    scope: t
  }, /* @__PURE__ */ E(sl, {
    scope: e.__scopeSelect,
    onNativeOptionAdd: X((S) => {
      z(
        (U) => new Set(U).add(S)
      );
    }, []),
    onNativeOptionRemove: X((S) => {
      z((U) => {
        const F = new Set(U);
        return F.delete(S), F;
      });
    }, [])
  }, o)), R ? /* @__PURE__ */ E($n, {
    key: M,
    "aria-hidden": !0,
    required: u,
    tabIndex: -1,
    name: d,
    autoComplete: s,
    value: Y,
    onChange: (S) => K(S.target.value),
    disabled: m
  }, Y === void 0 ? /* @__PURE__ */ E("option", {
    value: ""
  }) : null, Array.from(x)) : null));
}, dl = "SelectTrigger", Mn = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, disabled: n = !1, ...A } = e, i = St(o), c = De(dl, o), r = c.disabled || n, a = $(t, c.onTriggerChange), l = Ft(o), [d, s, m] = _n((C) => {
    const g = l().filter(
      (p) => !p.disabled
    ), f = g.find(
      (p) => p.value === c.value
    ), h = eA(g, C, f);
    h !== void 0 && c.onValueChange(h.value);
  }), u = () => {
    r || (c.onOpenChange(!0), m());
  };
  return /* @__PURE__ */ E(io, b({
    asChild: !0
  }, i), /* @__PURE__ */ E(V.button, b({
    type: "button",
    role: "combobox",
    "aria-controls": c.contentId,
    "aria-expanded": c.open,
    "aria-required": c.required,
    "aria-autocomplete": "none",
    dir: c.dir,
    "data-state": c.open ? "open" : "closed",
    disabled: r,
    "data-disabled": r ? "" : void 0,
    "data-placeholder": Xn(c.value) ? "" : void 0
  }, A, {
    ref: a,
    onClick: T(A.onClick, (C) => {
      C.currentTarget.focus();
    }),
    onPointerDown: T(A.onPointerDown, (C) => {
      const g = C.target;
      g.hasPointerCapture(C.pointerId) && g.releasePointerCapture(C.pointerId), C.button === 0 && C.ctrlKey === !1 && (u(), c.triggerPointerDownPosRef.current = {
        x: Math.round(C.pageX),
        y: Math.round(C.pageY)
      }, C.preventDefault());
    }),
    onKeyDown: T(A.onKeyDown, (C) => {
      const g = d.current !== "";
      !(C.ctrlKey || C.altKey || C.metaKey) && C.key.length === 1 && s(C.key), !(g && C.key === " ") && il.includes(C.key) && (u(), C.preventDefault());
    })
  })));
}), ul = "SelectValue", Kn = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, className: n, style: A, children: i, placeholder: c = "", ...r } = e, a = De(ul, o), { onValueNodeHasChildrenChange: l } = a, d = i !== void 0, s = $(t, a.onValueNodeChange);
  return oe(() => {
    l(d);
  }, [
    l,
    d
  ]), /* @__PURE__ */ E(V.span, b({}, r, {
    ref: s,
    style: {
      pointerEvents: "none"
    }
  }), Xn(a.value) ? /* @__PURE__ */ E(Bt, null, c) : i);
}), co = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, children: n, ...A } = e;
  return /* @__PURE__ */ E(V.span, b({
    "aria-hidden": !0
  }, A, {
    ref: t
  }), n || "▼");
}), yn = (e) => /* @__PURE__ */ E(Qn, b({
  asChild: !0
}, e)), He = "SelectContent", Jn = /* @__PURE__ */ O((e, t) => {
  const o = De(He, e.__scopeSelect), [n, A] = y();
  if (oe(() => {
    A(new DocumentFragment());
  }, []), !o.open) {
    const i = n;
    return i ? /* @__PURE__ */ jo(/* @__PURE__ */ E(Zn, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ E(Gt.Slot, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ E("div", null, e.children))), i) : null;
  }
  return /* @__PURE__ */ E(Cl, b({}, e, {
    ref: t
  }));
}), fe = 10, [Zn, Oe] = Te(He), Cl = /* @__PURE__ */ O((e, t) => {
  const {
    __scopeSelect: o,
    position: n = "item-aligned",
    onCloseAutoFocus: A,
    onEscapeKeyDown: i,
    onPointerDownOutside: c,
    side: r,
    sideOffset: a,
    align: l,
    alignOffset: d,
    arrowPadding: s,
    collisionBoundary: m,
    collisionPadding: u,
    sticky: C,
    hideWhenDetached: g,
    avoidCollisions: f,
    //
    ...h
  } = e, p = De(He, o), [B, Q] = y(null), [v, G] = y(null), q = $(
    t,
    (D) => Q(D)
  ), [Y, K] = y(null), [P, R] = y(null), x = Ft(o), [z, M] = y(!1), S = k(!1);
  L(() => {
    if (B)
      return Yn(B);
  }, [
    B
  ]), on();
  const U = X((D) => {
    const [W, ...ee] = x().map(
      (Z) => Z.ref.current
    ), [H] = ee.slice(-1), J = document.activeElement;
    for (const Z of D)
      if (Z === J || (Z == null || Z.scrollIntoView({
        block: "nearest"
      }), Z === W && v && (v.scrollTop = 0), Z === H && v && (v.scrollTop = v.scrollHeight), Z == null || Z.focus(), document.activeElement !== J))
        return;
  }, [
    x,
    v
  ]), F = X(
    () => U([
      Y,
      B
    ]),
    [
      U,
      Y,
      B
    ]
  );
  L(() => {
    z && F();
  }, [
    z,
    F
  ]);
  const { onOpenChange: te, triggerPointerDownPosRef: _ } = p;
  L(() => {
    if (B) {
      let D = {
        x: 0,
        y: 0
      };
      const W = (H) => {
        var J, Z, ne, Ae;
        D = {
          x: Math.abs(Math.round(H.pageX) - ((J = (Z = _.current) === null || Z === void 0 ? void 0 : Z.x) !== null && J !== void 0 ? J : 0)),
          y: Math.abs(Math.round(H.pageY) - ((ne = (Ae = _.current) === null || Ae === void 0 ? void 0 : Ae.y) !== null && ne !== void 0 ? ne : 0))
        };
      }, ee = (H) => {
        D.x <= 10 && D.y <= 10 ? H.preventDefault() : B.contains(H.target) || te(!1), document.removeEventListener("pointermove", W), _.current = null;
      };
      return _.current !== null && (document.addEventListener("pointermove", W), document.addEventListener("pointerup", ee, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", W), document.removeEventListener("pointerup", ee, {
          capture: !0
        });
      };
    }
  }, [
    B,
    te,
    _
  ]), L(() => {
    const D = () => te(!1);
    return window.addEventListener("blur", D), window.addEventListener("resize", D), () => {
      window.removeEventListener("blur", D), window.removeEventListener("resize", D);
    };
  }, [
    te
  ]);
  const [Ve, Ce] = _n((D) => {
    const W = x().filter(
      (J) => !J.disabled
    ), ee = W.find(
      (J) => J.ref.current === document.activeElement
    ), H = eA(W, D, ee);
    H && setTimeout(
      () => H.ref.current.focus()
    );
  }), ze = X((D, W, ee) => {
    const H = !S.current && !ee;
    (p.value !== void 0 && p.value === W || H) && (K(D), H && (S.current = !0));
  }, [
    p.value
  ]), xe = X(
    () => B == null ? void 0 : B.focus(),
    [
      B
    ]
  ), Qe = X((D, W, ee) => {
    const H = !S.current && !ee;
    (p.value !== void 0 && p.value === W || H) && R(D);
  }, [
    p.value
  ]), me = n === "popper" ? yo : ml, ae = me === yo ? {
    side: r,
    sideOffset: a,
    align: l,
    alignOffset: d,
    arrowPadding: s,
    collisionBoundary: m,
    collisionPadding: u,
    sticky: C,
    hideWhenDetached: g,
    avoidCollisions: f
  } : {};
  return /* @__PURE__ */ E(Zn, {
    scope: o,
    content: B,
    viewport: v,
    onViewportChange: G,
    itemRefCallback: ze,
    selectedItem: Y,
    onItemLeave: xe,
    itemTextRefCallback: Qe,
    focusSelectedItem: F,
    selectedItemText: P,
    position: n,
    isPositioned: z,
    searchRef: Ve
  }, /* @__PURE__ */ E(ro, {
    as: Re,
    allowPinchZoom: !0
  }, /* @__PURE__ */ E(nn, {
    asChild: !0,
    trapped: p.open,
    onMountAutoFocus: (D) => {
      D.preventDefault();
    },
    onUnmountAutoFocus: T(A, (D) => {
      var W;
      (W = p.trigger) === null || W === void 0 || W.focus({
        preventScroll: !0
      }), D.preventDefault();
    })
  }, /* @__PURE__ */ E(en, {
    asChild: !0,
    disableOutsidePointerEvents: !0,
    onEscapeKeyDown: i,
    onPointerDownOutside: c,
    onFocusOutside: (D) => D.preventDefault(),
    onDismiss: () => p.onOpenChange(!1)
  }, /* @__PURE__ */ E(me, b({
    role: "listbox",
    id: p.contentId,
    "data-state": p.open ? "open" : "closed",
    dir: p.dir,
    onContextMenu: (D) => D.preventDefault()
  }, h, ae, {
    onPlaced: () => M(!0),
    ref: q,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ...h.style
    },
    onKeyDown: T(h.onKeyDown, (D) => {
      const W = D.ctrlKey || D.altKey || D.metaKey;
      if (D.key === "Tab" && D.preventDefault(), !W && D.key.length === 1 && Ce(D.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(D.key)) {
        let H = x().filter(
          (J) => !J.disabled
        ).map(
          (J) => J.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(D.key) && (H = H.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(D.key)) {
          const J = D.target, Z = H.indexOf(J);
          H = H.slice(Z + 1);
        }
        setTimeout(
          () => U(H)
        ), D.preventDefault();
      }
    })
  }))))));
}), ml = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, onPlaced: n, ...A } = e, i = De(He, o), c = Oe(He, o), [r, a] = y(null), [l, d] = y(null), s = $(
    t,
    (q) => d(q)
  ), m = Ft(o), u = k(!1), C = k(!0), { viewport: g, selectedItem: f, selectedItemText: h, focusSelectedItem: p } = c, B = X(() => {
    if (i.trigger && i.valueNode && r && l && g && f && h) {
      const q = i.trigger.getBoundingClientRect(), Y = l.getBoundingClientRect(), K = i.valueNode.getBoundingClientRect(), P = h.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const J = P.left - Y.left, Z = K.left - J, ne = q.left - Z, Ae = q.width + ne, he = Math.max(Ae, Y.width), Me = window.innerWidth - fe, Xe = Co(Z, [
          fe,
          Me - he
        ]);
        r.style.minWidth = Ae + "px", r.style.left = Xe + "px";
      } else {
        const J = Y.right - P.right, Z = window.innerWidth - K.right - J, ne = window.innerWidth - q.right - Z, Ae = q.width + ne, he = Math.max(Ae, Y.width), Me = window.innerWidth - fe, Xe = Co(Z, [
          fe,
          Me - he
        ]);
        r.style.minWidth = Ae + "px", r.style.right = Xe + "px";
      }
      const R = m(), x = window.innerHeight - fe * 2, z = g.scrollHeight, M = window.getComputedStyle(l), S = parseInt(M.borderTopWidth, 10), U = parseInt(M.paddingTop, 10), F = parseInt(M.borderBottomWidth, 10), te = parseInt(M.paddingBottom, 10), _ = S + U + z + te + F, Ve = Math.min(f.offsetHeight * 5, _), Ce = window.getComputedStyle(g), ze = parseInt(Ce.paddingTop, 10), xe = parseInt(Ce.paddingBottom, 10), Qe = q.top + q.height / 2 - fe, me = x - Qe, ae = f.offsetHeight / 2, D = f.offsetTop + ae, W = S + U + D, ee = _ - W;
      if (W <= Qe) {
        const J = f === R[R.length - 1].ref.current;
        r.style.bottom = "0px";
        const Z = l.clientHeight - g.offsetTop - g.offsetHeight, ne = Math.max(me, ae + (J ? xe : 0) + Z + F), Ae = W + ne;
        r.style.height = Ae + "px";
      } else {
        const J = f === R[0].ref.current;
        r.style.top = "0px";
        const ne = Math.max(Qe, S + g.offsetTop + (J ? ze : 0) + ae) + ee;
        r.style.height = ne + "px", g.scrollTop = W - Qe + g.offsetTop;
      }
      r.style.margin = `${fe}px 0`, r.style.minHeight = Ve + "px", r.style.maxHeight = x + "px", n == null || n(), requestAnimationFrame(
        () => u.current = !0
      );
    }
  }, [
    m,
    i.trigger,
    i.valueNode,
    r,
    l,
    g,
    f,
    h,
    i.dir,
    n
  ]);
  oe(
    () => B(),
    [
      B
    ]
  );
  const [Q, v] = y();
  oe(() => {
    l && v(window.getComputedStyle(l).zIndex);
  }, [
    l
  ]);
  const G = X((q) => {
    q && C.current === !0 && (B(), p == null || p(), C.current = !1);
  }, [
    B,
    p
  ]);
  return /* @__PURE__ */ E(hl, {
    scope: o,
    contentWrapper: r,
    shouldExpandOnScrollRef: u,
    onScrollButtonChange: G
  }, /* @__PURE__ */ E("div", {
    ref: a,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: Q
    }
  }, /* @__PURE__ */ E(V.div, b({}, A, {
    ref: s,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...A.style
    }
  }))));
}), yo = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, align: n = "start", collisionPadding: A = fe, ...i } = e, c = St(o);
  return /* @__PURE__ */ E(wn, b({}, c, i, {
    ref: t,
    align: n,
    collisionPadding: A,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...i.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), [hl, ao] = Te(He, {}), Jo = "SelectViewport", kn = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, ...n } = e, A = Oe(Jo, o), i = ao(Jo, o), c = $(t, A.onViewportChange), r = k(0);
  return /* @__PURE__ */ E(Bt, null, /* @__PURE__ */ E("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ E(Gt.Slot, {
    scope: o
  }, /* @__PURE__ */ E(V.div, b({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, n, {
    ref: c,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...n.style
    },
    onScroll: T(n.onScroll, (a) => {
      const l = a.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: s } = i;
      if (s != null && s.current && d) {
        const m = Math.abs(r.current - l.scrollTop);
        if (m > 0) {
          const u = window.innerHeight - fe * 2, C = parseFloat(d.style.minHeight), g = parseFloat(d.style.height), f = Math.max(C, g);
          if (f < u) {
            const h = f + m, p = Math.min(u, h), B = h - p;
            d.style.height = p + "px", d.style.bottom === "0px" && (l.scrollTop = B > 0 ? B : 0, d.style.justifyContent = "flex-end");
          }
        }
      }
      r.current = l.scrollTop;
    })
  }))));
}), fl = "SelectGroup", [pl, Il] = Te(fl), Un = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, ...n } = e, A = Yt();
  return /* @__PURE__ */ E(pl, {
    scope: o,
    id: A
  }, /* @__PURE__ */ E(V.div, b({
    role: "group",
    "aria-labelledby": A
  }, n, {
    ref: t
  })));
}), Bl = "SelectLabel", Rn = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, ...n } = e, A = Il(Bl, o);
  return /* @__PURE__ */ E(V.div, b({
    id: A.id
  }, n, {
    ref: t
  }));
}), Tt = "SelectItem", [wl, Wn] = Te(Tt), Hn = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, value: n, disabled: A = !1, textValue: i, ...c } = e, r = De(Tt, o), a = Oe(Tt, o), l = r.value === n, [d, s] = y(i ?? ""), [m, u] = y(!1), C = $(t, (h) => {
    var p;
    return (p = a.itemRefCallback) === null || p === void 0 ? void 0 : p.call(a, h, n, A);
  }), g = Yt(), f = () => {
    A || (r.onValueChange(n), r.onOpenChange(!1));
  };
  if (n === "")
    throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
  return /* @__PURE__ */ E(wl, {
    scope: o,
    value: n,
    disabled: A,
    textId: g,
    isSelected: l,
    onItemTextChange: X((h) => {
      s((p) => {
        var B;
        return p || ((B = h == null ? void 0 : h.textContent) !== null && B !== void 0 ? B : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ E(Gt.ItemSlot, {
    scope: o,
    value: n,
    disabled: A,
    textValue: d
  }, /* @__PURE__ */ E(V.div, b({
    role: "option",
    "aria-labelledby": g,
    "data-highlighted": m ? "" : void 0,
    "aria-selected": l && m,
    "data-state": l ? "checked" : "unchecked",
    "aria-disabled": A || void 0,
    "data-disabled": A ? "" : void 0,
    tabIndex: A ? void 0 : -1
  }, c, {
    ref: C,
    onFocus: T(
      c.onFocus,
      () => u(!0)
    ),
    onBlur: T(
      c.onBlur,
      () => u(!1)
    ),
    onPointerUp: T(c.onPointerUp, f),
    onPointerMove: T(c.onPointerMove, (h) => {
      if (A) {
        var p;
        (p = a.onItemLeave) === null || p === void 0 || p.call(a);
      } else
        h.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: T(c.onPointerLeave, (h) => {
      if (h.currentTarget === document.activeElement) {
        var p;
        (p = a.onItemLeave) === null || p === void 0 || p.call(a);
      }
    }),
    onKeyDown: T(c.onKeyDown, (h) => {
      var p;
      ((p = a.searchRef) === null || p === void 0 ? void 0 : p.current) !== "" && h.key === " " || (rl.includes(h.key) && f(), h.key === " " && h.preventDefault());
    })
  }))));
}), lt = "SelectItemText", jn = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, className: n, style: A, ...i } = e, c = De(lt, o), r = Oe(lt, o), a = Wn(lt, o), l = gl(lt, o), [d, s] = y(null), m = $(
    t,
    (h) => s(h),
    a.onItemTextChange,
    (h) => {
      var p;
      return (p = r.itemTextRefCallback) === null || p === void 0 ? void 0 : p.call(r, h, a.value, a.disabled);
    }
  ), u = d == null ? void 0 : d.textContent, C = N(
    () => /* @__PURE__ */ E("option", {
      key: a.value,
      value: a.value,
      disabled: a.disabled
    }, u),
    [
      a.disabled,
      a.value,
      u
    ]
  ), { onNativeOptionAdd: g, onNativeOptionRemove: f } = l;
  return oe(() => (g(C), () => f(C)), [
    g,
    f,
    C
  ]), /* @__PURE__ */ E(Bt, null, /* @__PURE__ */ E(V.span, b({
    id: a.textId
  }, i, {
    ref: m
  })), a.isSelected && c.valueNode && !c.valueNodeHasChildren ? /* @__PURE__ */ jo(i.children, c.valueNode) : null);
}), El = "SelectItemIndicator", Ln = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, ...n } = e;
  return Wn(El, o).isSelected ? /* @__PURE__ */ E(V.span, b({
    "aria-hidden": !0
  }, n, {
    ref: t
  })) : null;
}), Zo = "SelectScrollUpButton", Pn = /* @__PURE__ */ O((e, t) => {
  const o = Oe(Zo, e.__scopeSelect), n = ao(Zo, e.__scopeSelect), [A, i] = y(!1), c = $(t, n.onScrollButtonChange);
  return oe(() => {
    if (o.viewport && o.isPositioned) {
      let a = function() {
        const l = r.scrollTop > 0;
        i(l);
      };
      const r = o.viewport;
      return a(), r.addEventListener("scroll", a), () => r.removeEventListener("scroll", a);
    }
  }, [
    o.viewport,
    o.isPositioned
  ]), A ? /* @__PURE__ */ E(Tn, b({}, e, {
    ref: c,
    onAutoScroll: () => {
      const { viewport: r, selectedItem: a } = o;
      r && a && (r.scrollTop = r.scrollTop - a.offsetHeight);
    }
  })) : null;
}), ko = "SelectScrollDownButton", Nn = /* @__PURE__ */ O((e, t) => {
  const o = Oe(ko, e.__scopeSelect), n = ao(ko, e.__scopeSelect), [A, i] = y(!1), c = $(t, n.onScrollButtonChange);
  return oe(() => {
    if (o.viewport && o.isPositioned) {
      let a = function() {
        const l = r.scrollHeight - r.clientHeight, d = Math.ceil(r.scrollTop) < l;
        i(d);
      };
      const r = o.viewport;
      return a(), r.addEventListener("scroll", a), () => r.removeEventListener("scroll", a);
    }
  }, [
    o.viewport,
    o.isPositioned
  ]), A ? /* @__PURE__ */ E(Tn, b({}, e, {
    ref: c,
    onAutoScroll: () => {
      const { viewport: r, selectedItem: a } = o;
      r && a && (r.scrollTop = r.scrollTop + a.offsetHeight);
    }
  })) : null;
}), Tn = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, onAutoScroll: n, ...A } = e, i = Oe("SelectScrollButton", o), c = k(null), r = Ft(o), a = X(() => {
    c.current !== null && (window.clearInterval(c.current), c.current = null);
  }, []);
  return L(() => () => a(), [
    a
  ]), oe(() => {
    var l;
    const d = r().find(
      (s) => s.ref.current === document.activeElement
    );
    d == null || (l = d.ref.current) === null || l === void 0 || l.scrollIntoView({
      block: "nearest"
    });
  }, [
    r
  ]), /* @__PURE__ */ E(V.div, b({
    "aria-hidden": !0
  }, A, {
    ref: t,
    style: {
      flexShrink: 0,
      ...A.style
    },
    onPointerDown: T(A.onPointerDown, () => {
      c.current === null && (c.current = window.setInterval(n, 50));
    }),
    onPointerMove: T(A.onPointerMove, () => {
      var l;
      (l = i.onItemLeave) === null || l === void 0 || l.call(i), c.current === null && (c.current = window.setInterval(n, 50));
    }),
    onPointerLeave: T(A.onPointerLeave, () => {
      a();
    })
  }));
}), Vn = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, ...n } = e;
  return /* @__PURE__ */ E(V.div, b({
    "aria-hidden": !0
  }, n, {
    ref: t
  }));
}), Uo = "SelectArrow", zn = /* @__PURE__ */ O((e, t) => {
  const { __scopeSelect: o, ...n } = e, A = St(o), i = De(Uo, o), c = Oe(Uo, o);
  return i.open && c.position === "popper" ? /* @__PURE__ */ E(En, b({}, A, n, {
    ref: t
  })) : null;
});
function Xn(e) {
  return e === "" || e === void 0;
}
const $n = /* @__PURE__ */ O((e, t) => {
  const { value: o, ...n } = e, A = k(null), i = $(t, A), c = Ia(o);
  return L(() => {
    const r = A.current, a = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(a, "value").set;
    if (c !== o && d) {
      const s = new Event("change", {
        bubbles: !0
      });
      d.call(r, o), r.dispatchEvent(s);
    }
  }, [
    c,
    o
  ]), /* @__PURE__ */ E(Ba, {
    asChild: !0
  }, /* @__PURE__ */ E("select", b({}, n, {
    ref: i,
    defaultValue: o
  })));
});
$n.displayName = "BubbleSelect";
function _n(e) {
  const t = Ie(e), o = k(""), n = k(0), A = X((c) => {
    const r = o.current + c;
    t(r), function a(l) {
      o.current = l, window.clearTimeout(n.current), l !== "" && (n.current = window.setTimeout(
        () => a(""),
        1e3
      ));
    }(r);
  }, [
    t
  ]), i = X(() => {
    o.current = "", window.clearTimeout(n.current);
  }, []);
  return L(() => () => window.clearTimeout(n.current), []), [
    o,
    A,
    i
  ];
}
function eA(e, t, o) {
  const A = t.length > 1 && Array.from(t).every(
    (l) => l === t[0]
  ) ? t[0] : t, i = o ? e.indexOf(o) : -1;
  let c = Ql(e, Math.max(i, 0));
  A.length === 1 && (c = c.filter(
    (l) => l !== o
  ));
  const a = c.find(
    (l) => l.textValue.toLowerCase().startsWith(A.toLowerCase())
  );
  return a !== o ? a : void 0;
}
function Ql(e, t) {
  return e.map(
    (o, n) => e[(t + n) % e.length]
  );
}
const vl = xn, tA = Mn, Yl = Kn, ql = co, oA = yn, nA = Jn, AA = kn, iA = Un, rA = Rn, cA = Hn, aA = jn, lA = Ln, bl = Pn, Dl = Nn, Ol = Vn, Gl = zn, Fl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arrow: Gl,
  Content: nA,
  Group: iA,
  Icon: ql,
  Item: cA,
  ItemIndicator: lA,
  ItemText: aA,
  Label: rA,
  Portal: oA,
  Root: vl,
  ScrollDownButton: Dl,
  ScrollUpButton: bl,
  Select: xn,
  SelectArrow: zn,
  SelectContent: Jn,
  SelectGroup: Un,
  SelectIcon: co,
  SelectItem: Hn,
  SelectItemIndicator: Ln,
  SelectItemText: jn,
  SelectLabel: Rn,
  SelectPortal: yn,
  SelectScrollDownButton: Nn,
  SelectScrollUpButton: Pn,
  SelectSeparator: Vn,
  SelectTrigger: Mn,
  SelectValue: Kn,
  SelectViewport: kn,
  Separator: Ol,
  Trigger: tA,
  Value: Yl,
  Viewport: AA,
  createSelectScope: al
}, Symbol.toStringTag, { value: "Module" })), Sl = (e) => /* @__PURE__ */ w.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("g", { clipPath: "url(#clip0_17_2062)" }, /* @__PURE__ */ w.createElement("path", { d: "M7.41 8.58997L12 13.17L16.59 8.58997L18 9.99997L12 16L6 9.99997L7.41 8.58997Z" }))), xl = (e) => /* @__PURE__ */ w.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("g", { clipPath: "url(#clip0_17_4631)" }, /* @__PURE__ */ w.createElement("path", { d: "M9.00016 16.17L4.83016 12L3.41016 13.41L9.00016 19L21.0002 6.99997L19.5902 5.58997L9.00016 16.17Z" }))), Ml = `
  inline-flex items-center justify-between flex-1
  bg-ll-background rounded-sm border
  py-1 pr-2 pl-3 min-w-[120px]
  data-[size=medium]:text-ll-font-size-p data-[size=medium]:h-8
  data-[size=large]:text-ll-font-size-h6 data-[size=large]:h-10
`, Kl = `
  overflow-hidden bg-ll-background rounded-sm shadow-md
  z-10 min-w-[120px]
  data-[size=medium]:text-ll-font-size-p
  data-[size=large]:text-ll-font-size-h6
`, yl = `
  font-sans font-inherit py-1 pr-8 pl-6 outline-none
  relative rounded-sm cursor-default text-ll-on-surface-variant1
  data-[highlighted]:bg-ll-primary
  data-[highlighted]:text-ll-on-primary
`, Jl = "font-inherit p-0", Zl = `
  absolute left-0 bottom-0
  inline-flex justify-center items-center
  h-full w-6
`, kl = ({ size: e = "medium", children: t, ...o }) => /* @__PURE__ */ j(tA, { className: Ml, "data-size": e, ...o, children: [
  t,
  /* @__PURE__ */ I(co, { children: /* @__PURE__ */ I(zt, { SVGElement: Sl, fill: Ye["--ll-color-on-background-variant1"] }) })
] }), Ul = ({ size: e = "medium", children: t, ...o }) => /* @__PURE__ */ I(nA, { className: Kl, "data-size": e, ...o, children: /* @__PURE__ */ I(AA, { className: Jl, children: t }) }), Rl = ({ children: e, ...t }) => /* @__PURE__ */ j(cA, { className: yl, ...t, children: [
  /* @__PURE__ */ I(aA, { children: e }),
  /* @__PURE__ */ I(lA, { className: Zl, children: /* @__PURE__ */ I(zt, { SVGElement: xl, fill: "currentColor", height: 12, width: 12 }) })
] }), Wl = () => /* @__PURE__ */ I(oA, {}), Hl = ({ children: e, label: t, ...o }) => /* @__PURE__ */ j(iA, { ...o, children: [
  /* @__PURE__ */ I(rA, { children: t }),
  e
] }), { Root: jl } = Fl, Ks = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Content: Ul,
  Group: Hl,
  Item: Rl,
  Portal: Wl,
  Root: jl,
  Trigger: kl
}, Symbol.toStringTag, { value: "Module" }));
function Ll(e, t) {
  return SA((o, n) => {
    const A = t[o][n];
    return A ?? o;
  }, e);
}
const lo = (e) => {
  const { present: t, children: o } = e, n = Pl(t), A = typeof o == "function" ? o({
    present: n.isPresent
  }) : Ze.only(o), i = $(n.ref, A.ref);
  return typeof o == "function" || n.isPresent ? /* @__PURE__ */ Vt(A, {
    ref: i
  }) : null;
};
lo.displayName = "Presence";
function Pl(e) {
  const [t, o] = y(), n = k({}), A = k(e), i = k("none"), c = e ? "mounted" : "unmounted", [r, a] = Ll(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return L(() => {
    const l = st(n.current);
    i.current = r === "mounted" ? l : "none";
  }, [
    r
  ]), oe(() => {
    const l = n.current, d = A.current;
    if (d !== e) {
      const m = i.current, u = st(l);
      e ? a("MOUNT") : u === "none" || (l == null ? void 0 : l.display) === "none" ? a("UNMOUNT") : a(d && m !== u ? "ANIMATION_OUT" : "UNMOUNT"), A.current = e;
    }
  }, [
    e,
    a
  ]), oe(() => {
    if (t) {
      const l = (s) => {
        const u = st(n.current).includes(s.animationName);
        s.target === t && u && Ho(
          () => a("ANIMATION_END")
        );
      }, d = (s) => {
        s.target === t && (i.current = st(n.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      a("ANIMATION_END");
  }, [
    t,
    a
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(r),
    ref: X((l) => {
      l && (n.current = getComputedStyle(l)), o(l);
    }, [])
  };
}
function st(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const sA = "Popover", [gA, Nl] = vt(sA, [
  bt
]), ot = bt(), [Tl, Ge] = gA(sA), dA = (e) => {
  const { __scopePopover: t, children: o, open: n, defaultOpen: A, onOpenChange: i, modal: c = !1 } = e, r = ot(t), a = k(null), [l, d] = y(!1), [s = !1, m] = Pt({
    prop: n,
    defaultProp: A,
    onChange: i
  });
  return /* @__PURE__ */ E(Bn, r, /* @__PURE__ */ E(Tl, {
    scope: t,
    contentId: Yt(),
    triggerRef: a,
    open: s,
    onOpenChange: m,
    onOpenToggle: X(
      () => m(
        (u) => !u
      ),
      [
        m
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: X(
      () => d(!0),
      []
    ),
    onCustomAnchorRemove: X(
      () => d(!1),
      []
    ),
    modal: c
  }, o));
}, Vl = "PopoverAnchor", uA = /* @__PURE__ */ O((e, t) => {
  const { __scopePopover: o, ...n } = e, A = Ge(Vl, o), i = ot(o), { onCustomAnchorAdd: c, onCustomAnchorRemove: r } = A;
  return L(() => (c(), () => r()), [
    c,
    r
  ]), /* @__PURE__ */ E(io, b({}, i, n, {
    ref: t
  }));
}), zl = "PopoverTrigger", CA = /* @__PURE__ */ O((e, t) => {
  const { __scopePopover: o, ...n } = e, A = Ge(zl, o), i = ot(o), c = $(t, A.triggerRef), r = /* @__PURE__ */ E(V.button, b({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": A.open,
    "aria-controls": A.contentId,
    "data-state": wA(A.open)
  }, n, {
    ref: c,
    onClick: T(e.onClick, A.onOpenToggle)
  }));
  return A.hasCustomAnchor ? r : /* @__PURE__ */ E(io, b({
    asChild: !0
  }, i), r);
}), mA = "PopoverPortal", [Xl, $l] = gA(mA, {
  forceMount: void 0
}), hA = (e) => {
  const { __scopePopover: t, forceMount: o, children: n, container: A } = e, i = Ge(mA, t);
  return /* @__PURE__ */ E(Xl, {
    scope: t,
    forceMount: o
  }, /* @__PURE__ */ E(lo, {
    present: o || i.open
  }, /* @__PURE__ */ E(Qn, {
    asChild: !0,
    container: A
  }, n)));
}, et = "PopoverContent", fA = /* @__PURE__ */ O((e, t) => {
  const o = $l(et, e.__scopePopover), { forceMount: n = o.forceMount, ...A } = e, i = Ge(et, e.__scopePopover);
  return /* @__PURE__ */ E(lo, {
    present: n || i.open
  }, i.modal ? /* @__PURE__ */ E(_l, b({}, A, {
    ref: t
  })) : /* @__PURE__ */ E(es, b({}, A, {
    ref: t
  })));
}), _l = /* @__PURE__ */ O((e, t) => {
  const o = Ge(et, e.__scopePopover), n = k(null), A = $(t, n), i = k(!1);
  return L(() => {
    const c = n.current;
    if (c)
      return Yn(c);
  }, []), /* @__PURE__ */ E(ro, {
    as: Re,
    allowPinchZoom: !0
  }, /* @__PURE__ */ E(pA, b({}, e, {
    ref: A,
    trapFocus: o.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: T(e.onCloseAutoFocus, (c) => {
      var r;
      c.preventDefault(), i.current || (r = o.triggerRef.current) === null || r === void 0 || r.focus();
    }),
    onPointerDownOutside: T(e.onPointerDownOutside, (c) => {
      const r = c.detail.originalEvent, a = r.button === 0 && r.ctrlKey === !0, l = r.button === 2 || a;
      i.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: T(
      e.onFocusOutside,
      (c) => c.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), es = /* @__PURE__ */ O((e, t) => {
  const o = Ge(et, e.__scopePopover), n = k(!1), A = k(!1);
  return /* @__PURE__ */ E(pA, b({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var c;
      if ((c = e.onCloseAutoFocus) === null || c === void 0 || c.call(e, i), !i.defaultPrevented) {
        var r;
        n.current || (r = o.triggerRef.current) === null || r === void 0 || r.focus(), i.preventDefault();
      }
      n.current = !1, A.current = !1;
    },
    onInteractOutside: (i) => {
      var c, r;
      (c = e.onInteractOutside) === null || c === void 0 || c.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (A.current = !0));
      const a = i.target;
      ((r = o.triggerRef.current) === null || r === void 0 ? void 0 : r.contains(a)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && A.current && i.preventDefault();
    }
  }));
}), pA = /* @__PURE__ */ O((e, t) => {
  const { __scopePopover: o, trapFocus: n, onOpenAutoFocus: A, onCloseAutoFocus: i, disableOutsidePointerEvents: c, onEscapeKeyDown: r, onPointerDownOutside: a, onFocusOutside: l, onInteractOutside: d, ...s } = e, m = Ge(et, o), u = ot(o);
  return on(), /* @__PURE__ */ E(nn, {
    asChild: !0,
    loop: !0,
    trapped: n,
    onMountAutoFocus: A,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ E(en, {
    asChild: !0,
    disableOutsidePointerEvents: c,
    onInteractOutside: d,
    onEscapeKeyDown: r,
    onPointerDownOutside: a,
    onFocusOutside: l,
    onDismiss: () => m.onOpenChange(!1)
  }, /* @__PURE__ */ E(wn, b({
    "data-state": wA(m.open),
    role: "dialog",
    id: m.contentId
  }, u, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), ts = "PopoverClose", IA = /* @__PURE__ */ O((e, t) => {
  const { __scopePopover: o, ...n } = e, A = Ge(ts, o);
  return /* @__PURE__ */ E(V.button, b({
    type: "button"
  }, n, {
    ref: t,
    onClick: T(
      e.onClick,
      () => A.onOpenChange(!1)
    )
  }));
}), BA = /* @__PURE__ */ O((e, t) => {
  const { __scopePopover: o, ...n } = e, A = ot(o);
  return /* @__PURE__ */ E(En, b({}, A, n, {
    ref: t
  }));
});
function wA(e) {
  return e ? "open" : "closed";
}
const os = dA, ns = uA, EA = CA, As = hA, QA = fA, is = IA, vA = BA, rs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Anchor: ns,
  Arrow: vA,
  Close: is,
  Content: QA,
  Popover: dA,
  PopoverAnchor: uA,
  PopoverArrow: BA,
  PopoverClose: IA,
  PopoverContent: fA,
  PopoverPortal: hA,
  PopoverTrigger: CA,
  Portal: As,
  Root: os,
  Trigger: EA,
  createPopoverScope: Nl
}, Symbol.toStringTag, { value: "Module" })), cs = "bg-none border-none p-0", as = "p-3 bg-ll-background shadow-md rounded-sm w-60 z-20", ls = "fill-ll-background shadow-lg", { Root: ss, Portal: gs } = rs, ds = ({
  side: e,
  children: t,
  sideOffset: o = so * 2,
  collisionPadding: n = so * 2
}) => /* @__PURE__ */ I(gs, { children: /* @__PURE__ */ j(
  QA,
  {
    side: e,
    className: as,
    sideOffset: o,
    collisionPadding: n,
    children: [
      /* @__PURE__ */ I(vA, { className: ls }),
      t
    ]
  }
) }), us = ({ children: e }) => /* @__PURE__ */ I(EA, { className: cs, children: e }), ys = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Content: ds,
  Root: ss,
  Trigger: us
}, Symbol.toStringTag, { value: "Module" })), Cs = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABNwAAADqCAYAAAB5oFizAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJstJREFUeNrs3c9uHEmeGOCsGQG6zGL4BlNj+DA+NfUEKp0ae1iI5Auo9AKWdFrYMEDy0oBPEucFVDrMwoddisJe9qYS4INvYt/sw6JrfPLB8HLgg01DaDqDjGomKZJikRH59/sa1UXxT1ZmRmTGL34ZGVkUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAx4xyLvwPP/xxvTgp1pYf9PPJyVcfelJ+L/w3OrnwzeLk8sLi355UfjCq/OPnk+UGnVR+Xn7/7K+K4uTiBv9c+dt//uFv56oCAAAAACk8yLz81+Vr0vqd8PDhvHzb/HJ8fKRKAAAAAHAfv7ILTk3K108PHj7csCsAAAAAuA8Jt3Ph1tf3Dx4+fFu+1uwOAAAAAO5Cwu1r0/L1+cHDh+t2BQAAAACrknC72rg4S7rt2BUAAAAArOKBXXCj7d+M/9Xjf/Mffvg0Gp0/W7XyZcxYxm+MKk9gLX+p+jTWX8V/nCz/ZjSqfL38/ujC7y+fozqqfOgovk5Gy6+vXq8LXxcX/lEue1T9Z7ms0S/bcjKqbtfZOvz6dF3O1vfX8Xeu3I7KMs8/YnRpvW6xvpd+MLq07Oq+KC6sy+nXiz99//1M1QUAAACaIuH2rR30m7+aFB140iq/mJevmd0AAAAANMUtpQAAAACQkIQbAAAAACQk4QYAAAAACUm4AQAAAEBCEm4AAAAAkJCEGwAAAAAkJOEGAAAAAAlJuAEAAABAQhJuAAAAAJCQhBsAAAAAJCThBgAAAAAJSbgBAAAAQEISbgAAAACQkIQbAAAAACQk4QYAAAAACUm4AQAAAEBCEm4AAAAAkJCEGwAAAAAkJOEGAAAAAAlJuAEAAABAQg/sAgAAAABS29zamtzm997v788rfzMu38bV733jM9bKt/XydVj+zVFbtl3CDQAAAIActi/9exzfF5e+P698PQ1/t7m19eSWSbfX8W+eXFpOoyTcAAAAAEju/f7+k+q/N7e2duL3d77xp4vy9aL4RgItjm7bKL5O4DXOHG4AAAAAtMlB+ZrE20tvMo2/u2jbBki4AQAAANAmfynOEmkvvvF74efv2rgBEm4AAAAAtM1ucTaC7UqbW1vhVtKj2z5coW4SbgAAAAC0yvv9/UX5dri5tTW95lfC6La9tq6/hBsAAAAAbRQSal/dVhrndlt/v78/a+uKS7idObILAAAAANrj/f5+mMdtbXNra3LpR9tFi0e3BRJuZ8Jjahd2AwAAAECrhMTas+U/Nre21sq3MH/brM0rLeFW+nJ8fFi+PSrOnoABAAAAQDvMytdGvI00mJavgzjHW2tJuEVfjo+PytdmcfYUDAAAAAAa9n5/P0wDFgZITeO3wpxu79q+3hJul3w5Pt4pzm4xNa8bAAAAQPPC4KgXm1tb4VbSo/f7+/O2r7CE2xW+HB+Hggu3mB7aGwAAAADNibePhhzN26LlD0tYeqDYrvbl+DgU5qMHv/mr1+X7uj1yamIXAAAAAA0It5GO3+/vz7qwshJu3/A//8t/flW+7IjS3/zDP57YCwAAAMAdze76OyHRtrm1dd2diK/K16JNGyrhBgAAAEB2t3my6E2/U/7scJXvN8kcbgAAAACQkIQbAAAAACQk4QYAAAAACUm4AQAAAEBCEm4AAAAAkJCEGwAAAAAkJOEGAAAAAAlJuAEAAABAQhJuAAAAAJCQhBsAAAAAJCThBgAAAAAJPbALANprY2trvXxbi/+sfl21iK/g6GB//9Ce62Q5zpdflGU4t9cAetkejMu3cfxn9euqo/J1qE1QjnCHePIw1r3Tr8t6d2TPNUfCDaA9DWh4fRffr2tEb7Os8LaIr9Do/li+5mWDu7CnW12O25fKcBmoK0OA7rUH40o78Li4Pilz23Y9mMe2fdkmuMDW/XI8lIijhnrn3NGQUc6F/+GHP34sTorJ8oN+Pjn56kNPyu+F/0YnF75ZnFxeWPzbk8oPRpV//Hyy3KCTys/L75/9VVGcXNzgnyt/+88//O1IVfi2v/mHfzz5ddibo7PdeXo/8mh0/nWlUo1G5/8aVfbuqPKPi9+/+nfCD0aXK2z8+Sj+73xdTr+e/+n7758orRtPumvx5J3KQhLgzuWwUb6elq9wnlyr4WMXscH9VL4OXPFKWo6P4/taTWX4IQZMRwPe95OEi+v9FeBLV8XvTQex18eDkdJ3L4dquz6u6WMPKu26eCxdOS7b9brKsdq2H3Z8/02SVvCBtDc1nz+OKnVOnyAjI9xgeEKn62PC5e2Wrx279VYNaTXJttHAKoTGexpfb8v1CUH6h7KRnSmdOwVFzxoox2oZFrEM35VleDDA/f/eeWwlr2MQn4qLle2Ssl0PnTAXL1fvJNdx0eXKVYiv1+W6hETNu/I104FeuRxDfPyiwXKcLM/R5bosirNE6l5Hk6gfEy9v1ON6N6nEk3XWu7XKueOXPkEh+ZachBtA/sZ0HIO4aUNB3I1Berl+oSO+FwP0hRK7thxD2b2MZbnWsjJcxE7Wm4EESi8SLy8EuztqObBCezCN56Jxi1ZteQtaSL7NirOEjdGKN5flshzXW7Ra4xhvvCzXb16cXVibKa1enT9C/LbdovNHNXEfkm+7+gRpSLgB5GtQx7ExnbZ8Vdfiem7HAF0j+3Vg9Lpo7qr3bYPzUIYvyvUNydPeJt7icTVJvf/CKJWhjRQE7tQetO3Cy3VC7DGNCZtdt4F/VZbTol0Jj+uE9m5Sru92LMeZ0nP+yNwnWJ479AkS+JVdAJC+QS1fb8svfyran2y7KkD/qVz/nRgYDL0cdyrl2IX9sUyehjJ82dOiedGx5QL9aBNexvZguyPtwdKkfH0s1/9jvGAx9HIMo8JDOYY4rUv7I6xruPXvp5gspFv1btrB84c+QQISbgB5AvKuB0PLpM3GQMsxdFA+d7BjtXQ6Kq/cjs9xXpq+lMtaxmNrojMKXNUehHNpcTbSucudzsmy8zzQcgwjmcPcYmH+zy6f68O6v5VA7Uy9W4/17m2Hzx8hFv6c+mEYQyHhBpAoERAb1K4H5FVhO96X2/V+KFe2YjmGMvzY8YB86fQhKT26Gp77tl6j3IBqm7BsD9Z7tFnbfbsYc4tyDBdDQ9K0TwmDsC2fezyavQ/1bqdH9W4c48nXSnY1Em4A929QQ0P6U88CuQubWJxdFV/veTkun+Dbt+A1JKjextucO99RzLz8qdsmgDga6nMP24Ol0N71PlkTL6KFEW19uhh6uX1/PaQLox2qdx9riFma8DKOrlTfbknCDeB+jWoIVj/2NJC7HNR97uu8IfHW2b6NYrhs2uWkW0xsj2uo54O8jRr45VxzmozqeXuw9LonF2OuK8ePAzmnn8YwkiCtqXd9vghfFOfzQqpvtyDhBnD3RjUEqUMbWv22b8PJYxIxXAEfQuDQ5aTbs5o+x22lMNx2PbQHnwfSHlTbhc996jxXkm3rAyrHsK3bjuJG693y4u3aQOqbpNstSLgB3K1RDUmL6UA3/2VfrojHztXbgZXftGsjFePE0HWt87qJgWGQ7foQ24PedZ4rybahJQIOy9euI7nR88f7gdW7cKyZ0+0bJNwAVm9Uh5xsW5p2Pek24M7V7GB/f9a1+lbz5z0rgKF1lt8OfDd0Puk24GTbonw9Kdv2I0ez80eNQpL3lRpwMwk3gNUaVcm2c9P4BCbBUXeEZNvzDq73swbqttskQGd5aJYJqy6W41CTbSHJtinZ1mi9G2qyTZL3FiTcAFYLyqf2xAXbHbw9cVJItnXtuBs38NEvHd4wiM6yW6IuWu/aCPZ4gWSIybYgJD0OVdvGzh8fB7jpkm0rkHADuF2jOilcAb/O6xh0dKEcx8XZHBtD09WRbcGzgX0uUE97sFYMb86l25rGp7B3xVCTbc8l2xo9f7wthjlXoGTbCiTcAG4flHO10/3TkVvwhti56myyLSZyJw19/Dg+cQzop9BZHtsN1+rExbT45PT1AZbPqw7Ox9qr42OA9U6y7Q4e2AUAtwrKm0zSHMbXn+O/5/F9rdLYfxe/bqrzED43PI6+tZOnxvnmmg6OQjmGQOXTFT/7bVy/9YT1rcsj24IXLfj8A6dA6Jc4eqvJhPoivj5dahuKShvwu0qb0GT886jF5Tgpmrv9/yjGY5+W5XfVaLPKU68nMVabJGjjQ9v+xpHcWL0L545pw6uxPIeEOveXK37+OMbmqfoFkm13JOEG8O1GtYmgPHTyP4T3bzRuB5fWdxyDuacNrPfL8vM/lOs7b2E5hg7LdkMB+bIs57cNVGI5bsSA6a7l2OlkWxwx2fQIs0koi3I/LpwNoTft+lpD7UHosL6L7fpN55T5FetbbdfrvAAY5nPbKdd3p6XlWPdUH8s2fe+2t3JWYqL5pdjyruV50PELaX04fzQ1xcxt+wap+wWSbfcg4QZwszonUw4N2V5xlii5Uwc//t0svGIjGzoV05r316OBl2MQymH3rrd7xHIMV6/fxHIMZfhihcB81oOAfFq04/bfsN899h761a7XeW4J7cDeXefaip3c0NE+KNuDcC56uWJ7cF/h4UizFl54CPthXHN89iZF0qFcxl3LM9QhybZhnT/uVfcu9QvWKvHkbY8dybZ7knADuEa8BbGuYC40hq9SNmixkX1ebsduDBDqGC0UroZP2zSvSHzK5aTGwGg35a0esRx3yu0Iy9wuvn37zKwnV79ftGQ9Qv2RcIN+tOvrRX0XoeaxPZgnbA+OKu3By6K+kXrhc563qBzHNbYRBzE+WyRf8MXy/Fb7LvExrPNHEOL3N6nKPC5neTF3p/h2oledS8BDEwCublTXagrmjmJj9jxXgxaCxPK1WX65WZzPEZM7MG+TutYnBOW/zzWvSqgf5Sskfp7cUI69SLbFOW/GLVmdtZi0BbqvrtHOIUHzJNcUC7E9CB3mR7FTnNu0MhdZW9r13KOMQjsbYrPN3KP7LrXvixvWReJjGOePcEw/Csd4xr7BTqxvhzesg2RbAhJuAFd7WUMwFxqz39c151m8haGO4HzclgRFXI9xTZ2rzToCk1hfrirHWY/mdXlhfYDE7cGkyD/a+Sh2lGuZ0D7epho6zbOhnAcr0yzkLscndY/Wv6Z9X67LoaO49+ePZSz3qI7yrpw/Dq/on0i2JSLhBtBMYDlrojGLV2lvuqKVSltGudWxHs/rflpYpRyPKgFaL5JtlQdGtMl6vJUE6K5nmZffSGIkjo56XuRPum3E83Pf2/XlxdBGElwxLqzGaa8k2wZx/gh2647lrqhvkm2JSbgBfN3hnxZ5R7fNc95CeofGNYdxfApXk+UYPj935+B5U/PVVcrxTc+eWJYq2b2cq6Rt6wXU3x6EtmCa8SMaH4VUU9Jtu+FyzP306qM2JBsq7ftmm+bEdf7IareppwFX6ttBIdmWnIQbwNdyXsUKwfhm0xsYG9Pcc7o963E5Bq+aDoRD5y7O+9InqYLaEDjupVyv2NkDhnteuUprbvmLSbd5xo9oevRx+Py1zOXYimRDHLl44NDt/fkjmDWVbLtU3zYl29KTcAOoRnJnV7EmGYO55y0K5hZF3uTfRlMJihqugh/UfRvpQI6/acLO1LtYx1N2gqdKCTop5wWY3Zbd8pfzYlrTD5HJOdLYrZs0cf447NldClwi4QZwqc8/oKB8OUHvm47uz6Y+9zRx6lBpdWdqUXkYyV4L1w+oqzE4m39xnGnx87ZdfIkX9XK2UU8bKsdQhusZy3HmaKHm80chnuw/CTeAi3JdxVq0eETUbpHvavjThrYp5+e+MuQ+W1CbqjN1cM3X99X43ITA6qeXoXWW462I80yLnyhH9AvSxN9GVfafhBvAeYd/rch39XS3rdsdk0d7uXZrzwJzV8HzSTl6bO9S/U6ZdHumqKBTHmda7izett5Wueb3DLeVThrYnlwX0t60vBxpVq66nvrBTrSUhBtA/kZ10YEkzZsi0yi3ugPzzJ+35zDJUmYh2T1NtLjDKzpP71Kubry1CRh2277b5o2OI2fmHdunTXymdp3rYpPQ1ue6EL/nbolhkHADOJetUW37hsdGf9aTwDzX5y08MSyblzmPt1huKQNbc7lBNzrMudqDg46MisoVfzzuSTnOjG6jgX5BYHTbQEi4AeQPIGcd2f53mZb7XU/K0VXwfFLepnmw4vfvYqrIoBMmmZb7oQsbHy82LDIser3mTcn1ee8cIjRQ72ZGtw2HhBtA3oZ13pVGNd5+kiMwH/ckQDK6LYP4EIJUdeSmIDZlxyrMYTRVetB6v9MeZFnXtZpvrc9x4e6o8jRruEquC7gf7NrheGAXAJwHkBrV08D8ZeJlrvegHA/ddpLNizqOt9CxKjuIoQzHCdd7pvig1cYZljnv2OiUTxna9eW+XXS4HJMmIjM/eGvVeMXoqfbWu8L0JMMi4QZQZJ0fpGuP+84SmIcr4XUkrDKW49xRkqW8QjCbqsyObhHEpkwor5frvx5HhgLtlCMB8qlLOyCcF8tzVa59W1fbOOlAOYb98bEFRf5EzJLMWDzJfbmlFCBvoNu1hjXX+o47XpQ/qs1ZpBzdNrvF7+y1eP2B9HKMeO5ih/mwI/u26/uEnsh4y/Qne3dYJNwAzuS4Ct65YC7ehtDlWxEmAvPOBLOhszZNuMh3t6jfi8RluRG3A2jnOSaHRQd3x6LD5ZjlNk2jk/mGsWORFCTcAM7kCMy7mrjKEYSud7lyCMzz9KMSHneHK5RR0ocnFJ5YCm2VK1HTxQ5zjlHaj2ta9yzzsjo8aMjCLhgWCTcAjWpXA2a6bTvhslZJos0Sb4fbSgG6xUMF0DegFhJuAPn8WSAqOOJr8eEW44SLnN32F+Nt0ymfEDbO+LAOoF3mHV1vI7pgNVnadU+8Hx4JNwAu84CAiwRH6T1LGb/GJNoqPiTeHqPcgDZzIQ2gARJuAEBt4pO/pgkXuXLy7GB/f5a4A7qR8YlmAAB0kIQbAJc9tgsuGNsFSU0TLusoJs/u4qDF2wW0U1fnI11XdAD1k3ADyEfiqh/GdkFSSW8nvcffvku8XW4rhf7rauLKg4tgNfMcC93Y2nIsDoyEGwB1MGEzIdCcFmkTmHt3/cOD/f0QTC9Sdmjj9gEMwcIugJUZbTowEm4AZ3IkhMYd3ReTDMvs9ITNG1tbAqQ0Uo5uWxzs79/3uD1o8fYB9zm4z5Lq2oMzOUbc1/Uk9hzxw8QRQkOMcBsYCTeAfAHduGtDx3sw8fs803LHDpEkndSUnZy9lizjQidOchZ6b2yd65Pgwsp1bZLEBzdZZFquGGFgJNwANKxVk0wB87zj9UOAdH+p5zg7SFAvw3F/2PLtBO4uR7KmU/OzxsTSuCP7VrtOK8T4IAfzOw+MhBtA3ob1acd2RY5A4KjGcpwLkFrb4dtIuMh5wmM29cMTNoycgNZwO2K+9a1zqoi5cqQBOfoGEr0DI+EGcC7H1VqBef1XwXMESBNJlHuZFmnnLUmZJEs9j1vq5CJwd59ydJg7Nv1Clgt/NY9cz9Gup76QFhKQ83u8jhyurZOj3oUHLE3s2uF4YBcA/CIkhlJfeToNzDOOoEsmzj01zrRf6w6QcmxHSKLMHCZ3kvo2y7dlfX3b4u3dVlegtx3mZXvwpiP7IMcFgLrb9R8zLPP0QloZnyVJdMW55p7cIwb7WBh11zafMpVJSILP7d5hMMINIG9AF3RlTqcXHduvNwVIOXgC5d06EaGzNx7YZo9dwYZWyNWp7UR7UJ6HpkWepyLWnXDL9XlGI9NEvZvatcMh4QaQPzCftv12xAxzbNWxX+v+PE+g7HHH1HZD/8TR5Tlu1VvvSFI913noU83lOO/Y/kG/4CZrMRnOAEi4AZwHdIeZAvOQzHrZ8s1/WeS5Cr6o+3bazPPKeALlCuI8R0MdQTDt2DxP0NvmPdNyt1t+/p0U+W5RnDewSTk+04U0boonQ58g1yi3bXt4GCTcAOoJzF+0dZRbTAq86Nj+bOpzp24VXK3eD3z7p6oANC7XaKxJy9uDXB36RUPz0n7o2H6iH+aZljs2ym0YJNwA6gno1loc1L0u8oxuy9nRaaocBeerGXow6XYlaF7OCz+v27jBZUc+jFqfdHB/NvG5Gy6kcYN3GZf9uu1TznB/Em4A1Whufz8EdLkezf6ybUFdnNA+1y1/i7g/+9bBmsTODDfXrWmRL5HbFa5gQ/Pt+lHGNiHM5bbTsnPvuMh7YehdQ+W4KPLd3vfakcI19S7UuUWmxYcY6a293G8SbgBXtK8Zl/2+LVez4rwlbzu6H5vsYJ0G522Z9yUkTVt6hdR8d2eMcoPmZR313JaLabEteF/ku9hxGBMQTdnLtNyQOJV04zo5k8wbbbkwF+NJcxomJuEGUF9AV8Qg+GPTCZL4+W+LvCOQ9npcjkUsx/WGy3EaO1cf25R0i51PQduZiYcnQLMO9vdnRb5RKsH7lnRUX2c+9zbdrue+C2HqaOEKs8zLf9t00r5yEf6jpFtaEm4AXwfm4ertPONHrBcNJkji537MHJQfNDSpcrUc55k7WGtNBibxc19X6tTnFgVJRnVdZN4/aF7OUSqNtgexTQid5WnGj8g9cvw27XrudXgr6cYV9S7EkrPMH/O+4XjyYzyPNX4u6xsJN4Cr7WZefiNJt9iAfi7yjz7aG0g5NhKYxLn3lsHR0rhox6i7tcLDEr7aLSZGhsa9KfKNjmqyPVgrX+9rOO/uxYRX39t1STeaiGvD+eNz3XXvUrLt8rnMcZCAhBvAFeLoqHnmjwmN3E91DSOPDWdoVMeZP2oe918bynFW5B3lVg2SXtZUjjvF9XP0tOHKpAdKXF0uG3YDNNoeHNXYaa6rPVh2lnOfX8K+e9OScgxt+izzx7w1pxuX6l3uu18u1L06LtJV+gXXxZOSzwlIuAFcb7eGz1gmSLI1rmH+qHj1O/ecbXXutzauTyjDj7kSqKFjVb7C6MTtW9apppJubie9mttKoXm5R7ldbg+ynIfjqLadop4R60FbRrdV2/Xc6xPmdPvs1joqntf0OSFh/zljPLlKv0DS7Z4k3ACuUdMot2rjGka77aRKvMUGNTSmPxX1ja6ZtWV0W6UcZzWWYwiOQicr2QS4lXJcpWPVyO0A8VbXsbPHlcZteZIhDLhdD0maui7CTGKn+W2qB6dUEm2hXa8rib8oWjK6rVKOYZ3qmLpiPXUZ0unzR6h3s7pihhjHfYyxVcrzx+cV+wWSbvfwwC4A7ulZeRJ+3NBnh8fTv8r8Gc9jw1THyLC1GEBvl/s0NOgfyu1baXLgmKwLjejTov5b2EJH5lVL6+mrWI51CYHJtCyPcAtCmKh7Hm9HuG05jmNn7Vl8v2t9CkHSMulYhxdOiTefL4v6kr9ZhU5Ak8fzKscTqycZmizfsmyfZF7+m3L7wrFY18ilZXswr7QHixWPt2q7vtbA8XbUwnr6Jp5TxzWWYYjJ3q0am32jbNdj22kkXTe8qvk4DDFgeNp5OGccxL7BfIX6lapfEOLJ72rod/WOhBtwX+OixyNaQlBcNjDhKmrdt4Mtg7sidtBD5/Iv8f3oiv3/uxisNRmw7bY0KD+de6Pcl7sNlOMvZVJ+/lEsv2VZXuVxhmOqlqRbJUmY0qLIPwdfnee2cEy3tfN6l05AUzyAIv/+nfR8G5cX0+o+ZibxfLlsC/58xXluLbYbv43vTZbFQcrkUuJ2/ajcj6Ec60wOh4TFRmzPQ2z2qTi7+DtfIfmxjAu+K5pJoJKm3r1vICYJd8O8rPQNFvEccpXv4t+k7BeEz14r98FzNeH2JNwAvt247sRRfE0FvZMOdH5CUP6mA+X4tGguKbnWYFnWkXTLkcx81VRnr/JE39RCwLzjzAqNtgdNXYRZavoC2W2EpNLzlpfjvCzHN0X9D+tZjhraiO3Fcn8d3vD7RrD15/xxEEc7NvkwpKb6BdMYT0q63ZI53ABu53lRz0TLXbRoe1CuHE9le+pa5ZaFpPWqyZEV8ZbFHLcteqgEtKPTvFP05BbvTDa7MBo33uLWhlvMqxfVLr8k2/rZL1gMdNuncW5hbkHCDeB2AV1oVDftia8cdSUoj+UYgvIhzz/xMlOQlOO2mDbcxpRjUu5xqgmQgXvbHHCn+Sav2vYApG94UrgoSr3x5FE8fwy13k3jAx3cEv0NEm4At29cQ/BpCPXXQflhx8pxVtT3lLq2Bkmpk245bsvaa0N1yRRMe7gE6DS31aztU0RcU46SbtRd74Z+EXdSnD1JVdLtBhJuAKs1rrNi2Mmaquc1Pv0ydTnuFPU92r2NpnGOsnsrlxMCrnHi9Ttc9Sl+GTtxOUbaTeJDJoB2dJola87Mujo3k3KkwX7BkC/GN/1gl9aTcANYvXHdKYadrAk6m2yrlOPzAZfj84QjE3PMSbbXon2Va12McoP2tAeHhblaZ12fCF3SjYbq3awYbtJt1tYnGbeFhBvA3RrX0LAOdRh555Ntl8pxpvzuJo7SmuYompZ14BYZFj11Gwa0qj0I552hJmtmfXnqoKQbDdW7EFcNLek287TSb5NwA7h74/pmYI1rCF57k2yrlOOQkqepy2+aKYBrW0cpxyi3HE92Be7XHgwxWfOmb53mSjku1GpqrHezYjgjZXcl225Hwg3g/o3rowE0riFofdK3ZFulHEPytM8TZ4ftepSh/HLcFvmhhfsvV713Wym0rz0IyZrfl6/Dnm/q8iLaqx6XY4jP5mo1NfcL+p7sfR6n1+EWJNwA0gXnfQ3qwm02j7r2NNI7lOPydqK+bedhjvLb2NqaFmejtFJatHEukDjibpZh0evxoRNAy4758hWSNX19SNLpCLC+XkS7VI6hXX+lVlNzv+BR0aLpMVLFaEWei7e9JuEGkD6o68soqbAdm+V2bbbwFr9sQVLPOllhyP+jTE/8zPGwhDYHp+8yLfdZAbS1Tdgp+jdaZdkuHA6oHMMo9qGMdjN3XXv6BZs96hcM4uJ7DhJunHrw8KGJmyFdUBdGu806vilh/X8/1CcPxU5Wl4Pz5ai2nRwL39jayvUY+L0W14l54eEJMMT2YF6+Qru+2/GO8zxnu9CBcjyMF0b7OMdW2J43MW6TENEvSCnEPYO6+J7aA7ugKP71v/uPJ+E9/O/k5PTLYhR/Nir/+XNxcv7LJ8vvn5TfL3753fBno/jDn+PfVX//5PyLi07OfjK68LOT4uTkihWNn7lc9qiy3Au/X/nHyUlxeUXO3y5t67/MP8yPF//t+Zfj44VaAfdqXE/nRSk70WFEzHamxES21S9frzKNiOpccF6+PSnLMUxs/7p8jTsSdO/GAC+nHHOPHXag3u3FupDay/K1UwBtbhN2yvZgFtv1acc6zK+GegHtinKcleV4EM+7oS3r8gWPRWyXZpIh+gUZ4slQt96oW/cj4cYvTv7v/wkH/08PHj7c/XJ8LPCH+zew8/JtHudoCkFdm59IGDoRuxJtV5ZjCMwP4pxloRzXhxwYxdFYOeryXgeqQzhOciTcwm2l2l1of3uwiB3n3dhxDufCtiZsQgyyJ9F2ZTmGdjIkUMPFqWXbPu7I6od1P4hlazRbd/sFbU28LeuXPkEiEm5cZfvBw4dPQ0Dx5fjYiRzSNbDj4jzx1obALjSkIclxoFG9VTnOyrdZDJSetaSjFcptN5ZhXVcgp5m2+6ADdeAojnCZJl70OIyk1DGGzrQH4dwbEm+vYlvQlosxkjErntOLs1sx38TR7E+Ldo5eXMRy/aSd6GW/IFdctWodCyPwjGhLTMKN64Sg4bPRbr207KD3ZVu6FqCH4PxVDOweF/Un30IAHhr6d4LxewdKy45WCNAnNQZLy8C7qTI8ynAOWXQowAtJ6j93sOqGQPqTc39v7doFjbQHyycYz2LnObQJz4p6k2/LJNsHyZh7leVyNPuybV/GaE0kQo5irBbO2V28KOp8dLd+wdOa65xzRw1GORf+hx/++LE4ORsqGT7o50tzhgUnp3OYnZzPeXb2za+mOlvON1adq2xU+cfPv8xrdlL5eRHnWTs5n3vtl9+/+HvxtwY9h9v/+qf/VPy///Hfrwtsn//13/39x1+HPxud/f3pEzdGo/OvK/tjNDr/16hS4KPKPy5+/+rfCT8YXa6w8eej+L/zdTn9ev6n779/4tCmS2KQPonB3XriQD0EbCEp82P42ki2rOU4ieX4XSzDccLkwmEMvOcSpQCtbw/WLrXrk4SLP7zUrmsT8pbl+qW2PXUy9TC28z8uy1asps5dOn+kjidDXTtw7qiHhFsh4XaLhNupv/67vy8k3KDWxnbtUpD++JpfP4qN5/Lr0+BNwNaKDteyHJcB+u9uCJxCuf2l8vVRHE0HQPfbhHE8/y/bhSImca4bzVIdkTqPbYIOcrvKstq+3zbhsYzNDt26xwp1bnKpvv32hroX6tifq/Gk+tYcCbdCwk3CDQAAACCdX9kFAAAAAJCOhBsAAAAAJCThBgAAAAAJSbgBAAAAQEISbgAAAACQkIQbAAAAACQk4QYAAAAACUm4AQAAAEBCEm4AAAAAkJCEGwAAAAAkJOEGAAAAAAlJuAEAAABAQhJuAAAAAJCQhBsAAAAAJCThBgAAAAAJSbgBAAAAQEISbgAAAACQkIQbAAAAACQk4QYAAAAACUm4AQAAAEBCEm4AAAAAkJCEGwAAAAAkJOEGAAAAAAlJuAEAAABAQhJuAAAAAJCQhBsAAAAAJCThBgAAAAAJSbgBAAAAQEISbgAAAACQ0IPMy39Vvtbs5m748r//5Wn59tKeAAAAALi7rAm3//rv/+2hXdwp8wcPH34q398WEqUAAAAAd+KWUi74cnx8UL79vnwd2BsAAAAAq5Nw4ytfjo+PytdmcXZL8JE9AgAAAHB7Em5c68vx8Zvy7Un5cmswAAAAwC09sAu4yZfj45Bse/Tg4cOd8v1xB1ZZchAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgKv9fgAEAulggap4jxLwAAAAASUVORK5CYII=", ms = `
  flex
  items-center
  justify-center
  text-decoration-none
  mt-[1px]
  w-full
  gap-1
`, hs = `
  h-5
  ml-1
`, fs = `
  leading-[initial]
`, Js = () => /* @__PURE__ */ j("a", { className: ms, href: "https://locallogic.co/", target: "_blank", rel: "noreferrer", children: [
  /* @__PURE__ */ I(
    pe,
    {
      variant: "caption1",
      weight: "--ll-font-weight-semibold",
      noMargin: !0,
      lineClamp: 1,
      color: "--ll-color-on-background-variant1",
      className: fs,
      children: "Powered by"
    }
  ),
  /* @__PURE__ */ I("img", { className: hs, src: Cs, alt: "Local Logic logo" })
] }), YA = (e) => /* @__PURE__ */ w.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" })), qA = (e) => /* @__PURE__ */ w.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" })), ps = ({ options: e }) => /* @__PURE__ */ I(
  xi,
  {
    SVGElement: e.style === "house" ? YA : qA,
    size: e.size || "large",
    backgroundColor: Ye["--ll-color-primary"],
    backgroundColorHighlight: Ye["--ll-color-primary-variant1"],
    renderForPrint: e.renderForPrint
  }
), Is = ({ options: e }) => /* @__PURE__ */ j("svg", { viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ I("defs", { children: /* @__PURE__ */ j("linearGradient", { id: "gradient", gradientTransform: "rotate(90)", children: [
    /* @__PURE__ */ I("stop", { offset: "20%", style: { stopColor: "#0d9488" } }),
    /* @__PURE__ */ I("stop", { offset: "80%", style: { stopColor: "#0f766e" } })
  ] }) }),
  /* @__PURE__ */ I(
    "circle",
    {
      cx: "18",
      cy: "18",
      r: "16.25",
      stroke: "white",
      strokeWidth: "1.75",
      fill: "url(#gradient)"
    }
  ),
  /* @__PURE__ */ I("svg", { fill: "white", width: "20", height: "20", x: "8", y: "8", children: e.style === "house" ? /* @__PURE__ */ I(YA, {}) : /* @__PURE__ */ I(qA, {}) })
] }), Bs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Zs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GoogleRoot: Is,
  Root: ps,
  Types: Bs
}, Symbol.toStringTag, { value: "Module" }));
export {
  Os as Alert,
  Js as Attribution,
  To as Button,
  xs as Chart,
  Ms as Demographics,
  Et as DemographicsTextCard,
  Qt as DonutChart,
  Fs as IconButton,
  Ci as Input,
  ni as Label,
  Ds as Link,
  Ss as LoadingItem,
  No as LoadingSpinner,
  xi as Marker,
  Zs as PinMarker,
  ys as Popover,
  zt as SVG,
  Ks as Select,
  Gs as Spacer,
  bs as Tag,
  pe as Text,
  qs as baseStyles,
  so as gridUnit,
  Ye as theme,
  Ys as useThemeSwitcher
};
